{
  "buffs": {
    "settingsCard": {
      "hint": "追加したバフを管理します。「設定」から通知を調整できます。",
      "add": "バフを追加",
      "empty": "バフがまだありません。追加すると、ここで通知を設定できます。",
      "edit": "{name}の設定",
      "threshold": "終了 {seconds} 秒前に通知",
      "reminderOff": "終了前の通知はオフ"
    },
    "manualTimer": {
      "label": "手動タイマー",
      "unit": "秒",
      "helpLabel": "手動タイマーについて",
      "help": "正確に認識できたらゲームに同期し、認識できなくてもカウントダウンを続けます。",
      "helpDetails": "ゼロになると設定秒数で繰り返します。秒数変更で再開始、切断で停止します。",
      "helpExample": "使用例：オンにした後、ホーリーシンボルの残り時間を一度認識させてください。その後、バフを受け損ねた回があっても、設定した間隔で通知を続けます。",
      "waiting": "カウントダウンの認識待ち",
      "running": "手動タイマー · {seconds}秒ごとに繰り返し",
      "remaining": "手動タイマー · 残り {value} 秒",
      "invalid": "1～86400の整数で秒数を入力してください"
    },
    "monitorNotReady": "監視の準備ができていません",
    "unrecognized": "未検出",
    "activeUntimed": "有効",
    "paused": "監視を一時停止",
    "frameInterrupted": "映像が中断",
    "remaining": "残り {value} 秒",
    "itemSettings": {
      "heading": "通知設定",
      "monitor": "このバフを監視してください",
      "nearing": "有効期限が切れる前に",
      "seconds": "秒",
      "visual": "アイコンの点滅",
      "speech": "音声アラート",
      "shared": "すべてのBUFFで共有",
      "priorityHint": "大きい数字が最初に読み上げられます",
      "speaking": "話す",
      "retryAudition": "もう一度音声を試してください",
      "delete": "バフを削除",
      "saving": "保存中…",
      "saved": "保存されました"
    },
    "imageRecognition": "画像マッチング",
    "defaultRegionHint": "デフォルトでは、複数の バフ 行をカバーし、下部のアクション バーを除く全幅の上位 30% を検索します。ボックスを移動したり、右下隅のサイズを変更したり、以下のパーセンテージを編集したりできます。",
    "dropShort": "または画像をドロップします",
    "localPrivate": "ローカルに保存されました",
    "catalogShort": "スキル · 非BUFFを含む",
    "itemCatalogShort": "アイテム · 非BUFFを含む",
    "source": "オンライン検索の種類",
    "skills": "スキル",
    "items": "アイテム",
    "searchItems": "アイテムを検索",
    "automaticDetection": "自動検出",
    "automaticDetectionHint": "BUFF を追加し、ゲームに接続すると、アイコンが特定され、自動的に秒数が読み取られます。手動で選択する必要はありません。",
    "close": "閉じる",
    "character": "キャラクターステータス",
    "clickSettings": "クリックして設定",
    "tooltipDrag": "ドラッグで並べ替え",
    "dragHint": "ドラッグして並べ替えます · Alt + 矢印キーで移動します",
    "save": "保存",
    "customRules": "カスタムリマインダー",
    "buffDefaults": "バフ リマインダー",
    "advanced": "その他の設定",
    "emptyBar": "気になるエフェクトを追加します。監視はゲームのキャプチャから始まります。",
    "filter": "職業でフィルタリングする",
    "adding": "追加",
    "addCount": "{count}を追加",
    "iconHint": "アイコンはサイズに合わせて縮小され、必要に応じて折り返されます。",
    "recognitionTab": "統計認識",
    "buffCalibration": "バフ 認識",
    "savedCount": "{count} BUFF が追加されました",
    "reconnectHint": "キャプチャが中断されました。上のキャプチャ パネルを使用してゲームを再接続します。",
    "autoHint": "バー内の BUFF は接続時に監視されます。停止するには 1 つ削除します",
    "previewHint": "統計にはサンプルデータが使用されます。 BUFF は現在のステータスを示します。サイズを変更するには、右下隅をドラッグします。",
    "skinSettings": "設定で統計スキンを変更する",
    "autoSaved": "設定はローカルに自動的に保存されます",
    "advancedDiagnostic": "高度な診断",
    "regionFields": {
      "x": "左",
      "y": "トップへ",
      "width": "幅",
      "height": "高さ"
    },
    "alertEvents": "いつ警告するか",
    "alertChannels": "アラートチャンネル",
    "previousPage": "前のページへ",
    "nextPage": "次のページ",
    "previewState": "プレビュー状態",
    "previewStates": {
      "live": "現状",
      "present": "アクティブ",
      "seconds": "期限切れ · 4 秒",
      "missing": "行方不明",
      "unknown": "未確認"
    },
    "title": "バフ マネージャー",
    "subtitle": "重要な効果を常に視界に入れて、冒険に集中してください。",
    "add": "バフ通知を追加",
    "start": "監視を開始する",
    "stop": "監視を停止する",
    "openPip": "ウィジェットを開く",
    "calibrationStates": {
      "waiting": "待っています",
      "confirming": "位置を特定する",
      "located": "位置",
      "missing": "まだ見つかりません",
      "disabled": "ターゲットは追加されていません",
      "failed": "認識に失敗しました",
      "cancelled": "キャンセルされました"
    },
    "locatedCount": "{count} / {total} を検出しました",
    "control": {
      "title": "バフモニター",
      "subtitle": "バー内のBUFFは、ゲーム画面の接続後に自動的に認識されます。",
      "settings": "モニター設定",
      "empty": "未設定",
      "emptyTitle": "監視するBUFFはまだありません",
      "emptyHint": "スキル、ポーション、またはその他のエフェクト画像を追加します。ゲームに接続すると監視が開始されます。",
      "waitingCapture": "ゲーム画面待ち",
      "waiting": "認識を待っています",
      "preparing": "準備中",
      "running": "モニタリング",
      "interrupted": "ゲーム画面待ち",
      "error": "認識エラー",
      "disabled": "ターゲットは追加されていません",
      "seconds": "{value}",
      "remindersHint": "デフォルトのルールはすべての バフ に適用され、項目ごとに上書きできます。"
    },
    "myBuffs": "監視するバフ",
    "enabledCount": "{count}が追加されました",
    "emptyTitle": "気になるBUFFを選択してください",
    "emptyHint": "小冊子のアイコンを参照するか、独自の画像を追加します。スキル、ポーション、その他の効果がサポートされています。",
    "state": {
      "idle": "開始されていません",
      "preparing": "準備中",
      "running": "モニタリング",
      "waiting": "バフ バーを見つけるのを待っています",
      "interrupted": "ゲーム画面を待っています",
      "error": "開始できません"
    },
    "present": "アクティブ",
    "missing": "行方不明",
    "unknown": "未確認",
    "idle": "開始されていません",
    "disabled": "障害者",
    "seconds": "{value} 秒",
    "edit": "設定",
    "name": "名前",
    "enabled": "モニタリングを有効にする",
    "remove": "削除",
    "undo": "削除を元に戻す",
    "removed": "{name}を削除しました",
    "up": "上に移動",
    "down": "下に移動",
    "reorder": "ドラッグして並べ替えます",
    "preview": "ウィジェットのプレビュー",
    "sample": "スタイルプレビュー・サンプル状態",
    "livePreview": "ライブステータス",
    "appearance": "表示設定",
    "mode": "内容",
    "combined": "統計 + バフ",
    "stats": "統計のみ",
    "buffs": "バフのみ",
    "arrangement": "モジュールのレイアウト",
    "auto": "自動",
    "vertical": "上下に配置",
    "horizontal": "左右に配置",
    "reverse": "モジュールの位置を交換する",
    "flow": "バフ レイアウト",
    "wrap": "ラップ",
    "row": "水平ストリップ",
    "column": "縦方向のリスト",
    "iconSize": "アイコンのサイズ",
    "gap": "アイコンの間隔",
    "showNames": "番組名",
    "hiddenCount": "{count} 詳細;ウィンドウをスクロールまたは拡大する",
    "enlarge": "もっと見るにはウィンドウを拡大してください",
    "noTargets": "バフを追加",
    "manage": "バフマネージャーを開く",
    "reminders": "デフォルトのリマインダー",
    "inherit": "デフォルトのリマインダールールを使用する",
    "threshold": "有効期限が切れる数秒前",
    "visual": "視覚的なアラート",
    "speech": "音声アラート",
    "nearing": "もうすぐ期限切れになります",
    "priority": "音声優先",
    "summary": "期限切れ前の {seconds} · {voice}",
    "voiceOn": "ボイスオン",
    "voiceOff": "声を消して",
    "volume": "ボリューム",
    "rate": "話す速度",
    "audition": "テスト音声",
    "speechError": "音声が再生できませんでした。ブラウザまたはシステムのオーディオ設定を確認してください。",
    "online": "小冊子のアイコン",
    "local": "ローカル画像",
    "search": "スキル名またはIDを検索する",
    "allJobs": "すべての職業",
    "catalogHint": "このスキル ディレクトリには、バフ 以外のスキルも含まれています。ポーションやその他のエフェクト画像をローカルに追加します。",
    "loading": "読み込み中",
    "retry": "再試行",
    "noResults": "一致するアイコンがありません",
    "added": "追加されました",
    "selected": "{count} が選択されました",
    "addSelected": "選択したBUFFを追加します",
    "cancel": "キャンセル",
    "done": "完了",
    "drop": "ここに画像をドロップするか、画像をコピーして貼り付けます",
    "upload": "画像を選択してください",
    "paste": "画像を貼り付ける",
    "imageFormats": "PNG、JPEG、WebP・各10MBまで",
    "localOnly": "画像はこのブラウザ内に残ります。ゲームのフレームはこのデバイスで処理されます。",
    "crop": "作物",
    "cropHint": "ドラッグしてアイコンを選択します。完全なイメージを保持するには、このダイアログを閉じます。",
    "applyCrop": "クロップを適用する",
    "duplicate": "この画像はすでに追加されています",
    "importError": "画像を追加できませんでした",
    "clipboardEmpty": "クリップボードに読み取り可能な画像がありません。 Ctrl+Vでも貼り付け可能です。",
    "connectionError": "接続に失敗しました",
    "catalogError": "アイコン ディレクトリは一時的に利用できません",
    "imageError": "アイコンのダウンロードに失敗しました",
    "saveError": "ローカルに保存できませんでした。ブラウザのストレージを確認してください。",
    "detection": "ゲーム画面と認識領域",
    "detectionHint": "全角および複数の バフ 行を自動的に検索します。手動選択はオプションです。最初にスキルをキャストする必要はありません。",
    "selectRegion": "地域を選択してください",
    "autoRegion": "自動領域",
    "regionHint": "ゲーム画面上をドラッグして、バフ 検索エリアを選択します。",
    "noCapture": "ゲーム ウィンドウを接続してフレームをプレビューします",
    "diagnostic": "ローカル診断をエクスポートする",
    "diagnosticHint": "視覚的な候補、表示される値、タイミングが含まれます。ゲームのスクリーンショットや自動アップロードはありません。",
    "clearDiagnostic": "明確な診断",
    "fpsLimited": "キャプチャ フレーム レートを調整できませんでした。認識の反応が遅くなる場合があります。",
    "nearingNotice": "{name}の効果がまもなく切れます",
    "exp": "経験値 / 時間",
    "more": "さらなるアクション",
    "resetData": "BUFFの画像、設定、アップロード音声も消去されます"
  },
  "ocrQuality": {
    "manualEnhancement": "手動領域・汎用補正",
    "preprocessRejected": "選択範囲が認識元に一致しないため、OCR に送信されていません。値全体を選択し、属性欄のラベルが見える状態にしてください。",
    "worldsLevelPreprocessRejected": "下部バーのレベル全体を確認できないため、OCR に送信されていません。レベルの数字全体を少し余白を残して選択してください。LV. を含める場合は、ラベル全体が見えるようにしてください。",
    "lowConfidence": "最後に読み取った「{text}」は {confidence} の信頼度です。少なくとも {minimumConfidence} が必要です。",
    "failed": "最後のレベル読み取り値は拒否されました: {reason}。",
    "retrying": "再試行中です。ゲームを目に見える状態に保ちます。",
    "minimumConfidence": "レベル信頼度のしきい値",
    "attempt": "レベル試行 {index}"
  },
  "firstUseCalibration": {
    "intro": "最初の接続でゲーム レイアウトを見つけます。ステータスバーを表示したままにしてください。インベントリを開いて、メル も見つけます。",
    "skip": "スキップ",
    "fallback": "位置が特定されていない、または以前にキャリブレーションされたエリアがないアイテムは、バックグラウンド検出が続行されている間、デフォルト設定を維持します。測定値は、その領域が特定された後に表示されます。",
    "storageFailed": "初回使用認識ステータスを保存できませんでした。今回の訪問は繰り返されませんが、次回も実行される可能性があります。"
  },
  "capability": {
    "insecureContext": {
      "title": "このページは安全にキャプチャまたは認識できません",
      "hint": "ウィンドウ共有とローカル認識には HTTPS が必要です。公式アドレスから Maple Log を開きます。",
      "action": "公式HTTPSサイトを開く"
    },
    "embedded": {
      "title": "Maple Log を独自のタブで開きます",
      "hint": "このページは埋め込みフレーム内にあるため、ウィンドウ共有とウィジェットが確実に動作しません。",
      "action": "別のタブで開く"
    },
    "mobile": {
      "title": "パソコンでこのサイトを開く",
      "hint": "ウィンドウキャプチャには Windows 版の Microsoft Edge、Google Chrome、Firefox を使用できます。ウィジェットを常に手前に表示するには Microsoft Edge または Google Chrome が必要です。履歴やランキングはスマートフォンでも閲覧できます。"
    },
    "unsupported": {
      "title": "このブラウザはゲーム ウィンドウをキャプチャできません",
      "hint": "ページのリンクをコピーし、最新のデスクトップ Microsoft Edge、Google Chrome、Firefox で開きます。"
    },
    "storage": {
      "title": "このブラウザはローカル 記録を保存できません",
      "hint": "プライベート モードまたはブロックされたサイト データにより、履歴と調整が保存されなくなる場合があります。ランクは引き続き表示できます。"
    },
    "simd": {
      "title": "このブラウザではローカル認識を実行できません",
      "hint": "WASM SIMD は使用できません。最新のデスクトップ Edge、Chrome、Firefox を使用してください。このブラウザではリソースはダウンロードされません。"
    },
    "popupHint": "このブラウザはゲームの上にウィジェットを保持できません。クリックすると、ストリーミング ツールが引き続きキャプチャできる通常のウィンドウが開きます。",
    "popupBlocked": "ブラウザがスタンドアロン ウィンドウをブロックしました。このサイトのポップアップを許可して再試行するか、公式の Edge / Chrome を使用してください。",
    "switchBrowser": "問題が解決しない場合は、最新のデスクトップ Microsoft Edge、Google Chrome、Firefox を試してください。"
  },
  "pip": {
    "chooseMode": "ウィジェットの表示方法を選択",
    "modeUnavailable": "このブラウザー環境では利用できません",
    "modes": {
      "pip": { "name": "ピクチャーインピクチャー", "hint": "最前面に表示。ブラウザーの PiP を使用します。" },
      "popup": { "name": "独立ウィンドウ", "hint": "PiP は使用しません。最前面には固定されません。" }
    },
    "open": "ウィジェットを開く",
    "opening": "開いています…",
    "dismiss": "閉じる",
    "retry": "もう一度開いてみてください",
    "retryPopup": "通常のウィンドウを開く",
    "copyLink": "ページのリンクをコピーする",
    "officialSite": "公式サイトを開く",
    "newTab": "新しいタブで開く",
    "help": "ヘルプを見る",
    "diagnostics": "診断を表示する",
    "copyDiagnostic": "コピー診断",
    "copied": "コピーされました",
    "copyFailed": "自動コピーできませんでした。以下のテキストを選択し、手動でコピーします。",
    "manualCopy": "手動でコピーするテキスト",
    "selectWindow": "ゲームウィンドウを選択してください",
    "retryOcr": "認識を再試行",
    "dashboard": "ダッシュボードでは引き続き統計を表示できます。",
    "captureFirst": "ゲーム ウィンドウに接続し、認識セットアップを完了すると、ダッシュボードにライブ統計が表示されます。",
    "helpText": "このページに戻り、「もう一度開いてみる」をクリックします。それでも失敗する場合は、デスクトップの Edge / Chrome を更新するか、ブラウザーと組織の制限を確認してください。",
    "popupBadge": "通常のウィンドウ",
    "popupHint": "通常のウィンドウとして開きます。ゲームの手前に固定することはできません。",
    "popupHelp": "ウィンドウがブロックされている場合は、このサイトのポップアップを許可して、もう一度試してください。ゲーム上で必要な場合は、公式デスクトップの Edge または Chrome を使用してください。",
    "refreshHint": "再試行しても問題が解決しない場合は、このページを更新する前に現在の記録を終了してください。",
    "localDiagnostic": "ブラウザ情報、機能チェック、エラー カテゴリのみが含まれます。このページのセッションのために保持され、自動的にアップロードされることはありません。",
    "insecure-context": {
      "title": "このページはウィジェットを開けません",
      "hint": "ページは安全なコンテキストにありません。 HTTPS アドレスを通じて Maple Log にアクセスします。"
    },
    "embedded": {
      "title": "Maple Log を独自のタブで開きます",
      "hint": "このページは埋め込みフレーム内にあります。ウィジェットを使用するには、別のブラウザー タブで開きます。"
    },
    "unsupported": {
      "title": "このブラウザではウィジェットを使用できません",
      "hint": "リンクをコピーし、最新のデスクトップ Microsoft Edge または Google Chrome で開きます。"
    },
    "not-connected": {
      "title": "まずゲームウィンドウを接続してください",
      "hint": "実行中のゲームウィンドウを選択し、認識設定を完了して、「ウィジェットを開く」をクリックします。"
    },
    "ocr-preparing": {
      "title": "画面認識の準備",
      "hint": "ゲームの接続と認識のセットアップが完了するまで待ってから、「ウィジェットを開く」をクリックします。"
    },
    "ocr-error": {
      "title": "画面認識の準備ができていません",
      "hint": "セットアップを完了できませんでした。ウィジェットを開く前に認識を再試行してください。"
    },
    "ending": {
      "title": "記録を終了する",
      "hint": "記録が保存された後、ウィジェットを開くことができます。"
    },
    "reloading": {
      "title": "リフレッシュの準備中",
      "hint": "ページが更新された後、ウィジェットを開くことができます。"
    },
    "request-denied": {
      "title": "ブラウザはこの試行を許可しませんでした",
      "hint": "このページに戻り、「もう一度開いてみる」をクリックします。これによりスタンドアロン ウィンドウが開く場合は、このサイトのポップアップを許可します。",
      "fallbackTitle": "常時表示は利用できません",
      "fallbackHint": "このブラウザはゲームの上にウィジェットを保持できません。以下をクリックすると通常のウィンドウが開きます。ストリーミング ツールは引き続きそれをキャプチャできます。"
    },
    "resource-load": {
      "title": "ウィジェットのコンテンツを読み込めませんでした",
      "hint": "インターネット接続を確認して、もう一度試してください。"
    },
    "unknown": {
      "title": "ウィジェットを開けませんでした",
      "hint": "もう一度試してください。それでも失敗する場合は、診断をコピーしてフィードバックに含めてください。"
    }
  },
  "performance": {
    "buffCadence": "低・中設定では、残り時間・効果終了・状態変化の確認時に、BUFF の認識間隔が一時的に 0.5 秒になります。カウントダウンは継続して更新されます。",
    "buffFrequency": "BUFF 認識",
    "help": {
      "entry": "動作が重い場合",
      "title": "動作が重い場合",
      "graphics": "グラフィックアクセラレーションをオフにする",
      "systemLagTitle": "システム操作も固まりますか？",
      "systemLagIntro": "日本語入力、システムメニュー、Alt+Tab も固まる場合は、画面表示やデスクトップ装飾ソフトとの競合が考えられます。",
      "conflictAction": "競合するソフトを終了する",
      "conflictHint": "MSI Afterburner / RivaTuner、Nexus などを終了してから、もう一度試してください。",
      "widgetAction": "ウィジェットを閉じるか別のウィンドウで開く",
      "widgetHint": "まずウィジェットを閉じます。使う場合はボタン右側の矢印から「{mode}」を選びます。",
      "firefoxAction": "Firefox に切り替える",
      "firefoxHint": "改善しなければ Firefox を試してください。ウィジェットは最前面にできないため「{mode}」を使います。",
      "browserTipsTitle": "ページや認識処理が重い場合",
      "system": "{browser} · システム設定",
      "webpages": "{browser} · ウェブページの設定",
      "firefox": "Firefox · パフォーマンス → 推奨設定のチェックを外し、ハードウェア アクセラレーション",
      "manual": "ブラウザの設定でグラフィックスまたはハードウェア アクセラレーションを見つけて、利用可能な場合はオフにします。",
      "copyLink": "アドレスをコピーする",
      "copied": "コピーされました",
      "pasteHint": "アドレスバーに貼り付け、アクセラレーションをオフにしてブラウザーを再起動します。",
      "copyFailed": "コピーに失敗しました。上記のアドレスを手動でコピーします。",
      "gameAcceleration": "コンピューター ゲーム アクセラレーションをオフにする",
      "gameAccelerationGuide": "{browser} · パフォーマンス設定",
      "gameAccelerationPaste": "アドレスバーに貼り付け、ゲームアクセラレーションをオフにしてブラウザーを再起動します。",
      "lower": "認識処理の負荷を下げる",
      "currentTier": "現在: {tier} · 低いほど、使用するリソースが少なくなります",
      "lowerAction": "レベルを下げる",
      "lowest": "最低でも",
      "backgroundHint": "バックグラウンドでの記録停止を防ぐ",
      "backgroundAction": "セットアップ"
    },
    "navigation": {
      "tier": "間隔",
      "advanced": "上級者向け",
      "diagnostics": "診断"
    },
    "loadLevel": "認識負荷",
    "frequencyOverview": "周波数の概要",
    "manualTuning": "微調整",
    "localOnly": "ローカルのみ",
    "title": "認識性能",
    "hint": "端末に合った設定で、画面キャプチャ・画像の確認・各項目の読み取り頻度をまとめて調整します。",
    "tiers": {
      "low": "低い",
      "medium": "中",
      "default": "デフォルト",
      "high": "高",
      "ultra": "ウルトラ"
    },
    "tierHints": {
      "low": "更新が著しく遅くなり、負荷が最小限に抑えられます。",
      "medium": "より多くのリソースを節約する必要があるデバイスの負荷を軽減します。",
      "default": "1 秒に 1 回キャプチャと検査を行い、リソースの使用量と更新速度のバランスをとります。",
      "high": "より高速なアップデートが必要な安定したデバイスでは、より頻繁に読み取りの機会を得ることができます。",
      "ultra": "最も頻繁に読む機会があり、負荷が高くなります。機器の性能に合わせてお選びください。"
    },
    "tierDetails": "プリセットの詳細を表示する",
    "advanced": "高度な認識設定",
    "everySeconds": "{count}秒ごとに1回",
    "demand": "承認欲求",
    "resetAdvanced": "推奨値を復元する",
    "lessLoad": "より低い負荷",
    "fasterUpdates": "アップデートの高速化",
    "recommended": "おすすめ",
    "captureShort": "スクリーンキャプチャ",
    "processingShort": "フレーム検査",
    "detailHint": "各メトリクスの読み取り間隔",
    "advancedHint": "厳密さと画面変更の感度",
    "diagnosticHint": "実行時の測定値はローカルに保存されます",
    "targetHint": "これらは目標間隔です。実際の読み取りは、新しいフレームの配信、OCR の継続時間、メトリクスのスケジューリングにより遅くなる可能性があります。デマンド駆動型検査の最小間隔は 125 ミリ秒です。",
    "pendingCapture": "認識設定が適用されました。キャプチャ率は次の共有に適用されます。",
    "deferred": "最新の選択を適用する前に、サンプリングの開始/終了を終了します。キャプチャの変更は次の共有に適用されます。",
    "finalSampleIncomplete": "最終サンプリングが不完全でした。以前に確認された結果は記録として残されています。",
    "captureLimit": "スクリーンキャプチャのフレームレート制限",
    "captureHint": "現在の共有を中断することなく、次回ソースを選択するときに適用されます。実際のレートはブラウザとソースによって異なります。",
    "processingLimit": "フレーム検査レート制限",
    "processingHint": "定期的なフレーム検査にすぐに適用されます。記録の開始または終了時に必要なサンプルは除外されます。",
    "defaultCapture": "デフォルト (10 FPS を要求)",
    "defaultProcessing": "デフォルト（認識要求）",
    "fps": "{count} FPS",
    "tradeoff": "制限を低くすると負荷は軽減されますが、更新が遅くなり、視覚的な簡単な変更が見逃される可能性があります。",
    "reportTitle": "ローカル診断レポート",
    "reportHint": "このページのタイミング、レート、エラー カテゴリは実行のみです。スクリーンショット、OCR テキスト、ウィンドウ タイトルは使用できません。自動的にアップロードされることはありません。リロードするとレポートがクリアされます。",
    "refresh": "レポートを更新する",
    "copy": "レポートのコピー",
    "download": "JSONをダウンロード",
    "clear": "クリアレポート",
    "details": "レポートの詳細を表示する",
    "reportedFps": "ブラウザ報告のキャプチャ率",
    "frameTime": "平均フレーム処理時間",
    "ocrTime": "平均 OCR 時間",
    "resets": "OCRエンジンのリセット",
    "unavailable": "まだデータがありません",
    "milliseconds": "{count} ミリ秒",
    "count": "{count}",
    "copied": "レポートをコピーしました",
    "copyFailed": "コピーに失敗しました。代わりに、レポートの詳細からテキストをコピーします。",
    "downloaded": "ダウンロードされたレポート",
    "downloadFailed": "ダウンロードに失敗しました。代わりにレポートをコピーしてみてください。",
    "cleared": "レポートがクリアされました",
    "refreshed": "レポートが更新されました",
    "limitation": "フレーム レートはブラウザによって報告されます。タイミングはこのページで測定されます。 Windows エクスプローラー、システム CPU および GPU 使用率は利用できません。ステージごとに最大 240 個の最近のサンプルと 40 個の最近のエラーが保持されます。"
  },
  "stream": {
    "connect": {
      "entry": "配信に表示",
      "title": "配信に表示する方法",
      "step1Title": "ウィジェットを開く",
      "step1": "ウィンドウの端をドラッグしてサイズを変更します。",
      "open": "ウィジェットを開く",
      "opening": "開いています",
      "openFailed": "ウィジェットを開けませんでした。ブラウザでピクチャーインピクチャーを許可して、再試行してください。",
      "unsupported": "デスクトップの Chrome または Edge を使用してウィジェットを開きます。",
      "step2Title": "背景色を選択してください",
      "step2": "ストリーミング ツールで削除できるように、テキストやアイコンとは異なる単色を選択します。",
      "copyColor": "カラーコードをコピー",
      "copied": "コピーされました",
      "copyFailed": "コピーに失敗しました。カラー値を手動でコピーします。",
      "solidNeeded": "この背景は透明度があります。キーイングには不透明な単色を選択します。",
      "step3Title": "ストリーミング ツールにウィジェットを追加する",
      "capture": "ウィンドウ キャプチャを追加し、「Maple Log」ウィジェット ウィンドウを選択します。",
      "keyColor": "タイトル バーと下部のコントロールを切り取り、クロマ キーまたはカラー キー フィルターを追加し、上の背景色と一致させます。",
      "note": "ストリーミング中はメイン ページとウィジェットを開いたままにしてください。",
      "done": "わかりました"
    },
    "camp": "雪原遠征",
    "clockwork": "ルディブリアム・ブロックステーション",
    "pinkbean": "ピンクビーン・ラジオ",
    "kerning": "カニングシティ・グラフィティ",
    "aqua": "アクアロード航海",
    "ellinia": "エリニア・森のささやき",
    "orbis": "オルビス・雲の庭園",
    "temple": "時間の神殿・時の回廊",
    "zakum": "ジャクム・溶岩の祭壇",
    "skins": "スキン",
    "transparent": "透明 (デフォルト)",
    "white": "ホワイト",
    "transparentShort": "透明",
    "charcoal": "ダークグレー",
    "magentaShort": "マゼンタ",
    "greenShort": "緑",
    "blueShort": "ブルー",
    "hexColor": "16進数の色",
    "colorInvalid": "#FFFFFF や #FFFFFF80 などの有効な 16 進数カラーを入力します。",
    "customColor": "カスタムカラー",
    "opacity": "不透明度",
    "daily": "通常の外観",
    "title": "配信用の外観",
    "classic": "アドベンチャー HUD",
    "mushroom": "メイプルキノコ",
    "minimal": "シンプルな統計",
    "hint": "ウィンドウを縮小すると、メル、BUFF の順に非表示になります。経験値効率は常に表示されます。",
    "classicHint": "シルバーバッジ · セグメント化された HUD",
    "mushroomHint": "メイプルキノコ・クリーム色のプラーク",
    "minimalHint": "白抜き図・オープンバックグラウンド",
    "preview": "レイアウトプレビュー",
    "strip": "横長",
    "classicLayout": "クラシック",
    "portrait": "縦長",
    "backgroundHelpLabel": "背景の透明度について",
    "backgroundHelp": "透明性は Web コンテンツに適用されます。ブラウザーは引き続きピクチャー・イン・ピクチャー・ウィンドウの背景を描画するため、その背後にあるアプリは非表示のままになります。ストリーミングするには、無地の背景を選択し、ウィジェット ウィンドウをキャプチャし、ストリーミング ツールのクロマ キー フィルターを使用してその色を削除します。",
    "background": "ウィジェットの背景",
    "magenta": "マゼンタ背景",
    "green": "グリーンバック",
    "blue": "ブルーバック",
    "solid": "ダークグレープレビュー (キーなし)",
    "motion": "ゲームアニメーション",
    "motionHint": "穏やかなアイドル動作とレベルアップ動作。モーションの軽減を尊重します。",
    "obs": "OBS をセットアップする",
    "obsSteps": "ウィンドウ キャプチャを追加してウィジェットを選択 → ブラウザのタイトル バーをトリミング → クロマ キー フィルターを追加 → ウィジェットの背景色と一致します。",
    "obsNote": "チェッカーボードは透明度を表します。透明な Web ページは、透明なピクチャ イン ピクチャ ウィンドウを保証するものではありません。 OBS キャプチャの場合は、単色の背景とクロマ キー フィルターを使用します。",
    "obsColor": "マゼンタキー: #FF00FF。カスタム カラーを使用して、類似性と滑らかさを調整します。ポーションのアイコンとテキストの端がそのまま残っていることを確認してください。",
    "controls": "下部のコントロールから記録を開始、一時停止、または終了します。ストリーミング時にトリミングしてください。",
    "sample": "サンプルデータ",
    "exp": "経験値/時",
    "mesos": "メル/時",
    "level": "レベル",
    "eta": "レベルアップまで",
    "gained": "純増経験値",
    "net": "純増メル",
    "elapsed": "記録時間",
    "start": "開始時の所持メル",
    "balance": "所持メルの増減",
    "full": "1レベル分",
    "map": "マップ",
    "recording": "記録中"
  },
  "captureRecovery": {
    "source-endedTitle": "共有が終了しました。現在のゲームウィンドウを選び直してください",
    "source-endedHint": "ゲームウィンドウを閉じたり開き直したりした場合は、ページを再読み込みせずに共有元を選び直してください。アカウントを切り替える場合は、前の記録を終了してから新しいアカウントの記録を開始してください。",
    "permission-deniedTitle": "ウィンドウ共有権限が付与されていませんでした",
    "security-restrictedTitle": "ウィンドウ共有はセキュリティまたは権限によって制限されています",
    "security-restrictedHint": "ブラウザ、オペレーティング システム、または組織の共有権限を確認して、ゲーム ウィンドウを再度選択してください。",
    "invalid-stateTitle": "このページに戻って再度選択してください",
    "invalid-stateHint": "このページに戻り、もう一度「ゲーム ウィンドウを選択」をクリックして共有を開始します。",
    "insecure-contextTitle": "このページでは安全に共有を開始できません",
    "insecure-contextHint": "ウィンドウ共有には安全な接続が必要です。 HTTPS 経由で公式 Maple Log サイトを開いて、もう一度試してください。",
    "embeddedTitle": "Maple Log を独自のタブで開きます",
    "embeddedHint": "このページは埋め込みフレーム内にあります。ウィンドウを共有する前に、別のブラウザー タブで開きます。",
    "mobileTitle": "リアルタイム認識はパソコンで",
    "mobileHint": "Windows 版 Edge / Chrome / Firefox に対応。スマートフォンでも履歴やランキングを閲覧できます。",
    "mobileCopyLink": "リンクをコピー",
    "policy-blockedTitle": "このページではウィンドウ共有が許可されていません",
    "policy-blockedHint": "別のタブで Maple Log を開いて、再試行してください。それでも失敗する場合は、ブラウザまたは組織の共有制限を確認してください。",
    "openOfficial": "公式HTTPSサイトを開く",
    "openStandalone": "別のタブで開く",
    "browserHelp": "ブラウザのアップデートと切り替えのヘルプ",
    "updateSteps": "以下のアドレスをコピーしてブラウザのアドレス バーに貼り付け、開いて {browser} の更新を確認します。アップデート後にブラウザを再起動してください。",
    "updateMenu": "ブラウザ メニューの [ヘルプ] または [バージョン情報] からアップデートを確認するか、最新のデスクトップ Edge / Chrome / Firefox を使用してください。",
    "copyUpdateAddress": "更新アドレスをコピーする",
    "downloadEdge": "Microsoft Edgeをダウンロード",
    "downloadChrome": "Google Chromeをダウンロード",
    "downloadFirefox": "Firefox をダウンロード",
    "copyPageLink": "このページのリンクをコピーする",
    "linkCopied": "アドレスがコピーされました。ブラウザのアドレスバーに貼り付けて開きます。",
    "linkCopyFailed": "自動コピーに失敗しました。以下のアドレスを手動で選択してコピーします。",
    "manualAddress": "手動コピー用のアドレス",
    "screenSteps": "下のボタンをクリックしてください。ブラウザ共有ダイアログで「画面全体」を選択し、ゲームが含まれる画面を選択して「共有」をクリックします。",
    "tryScreen": "画面全体をキャプチャしてみてください",
    "retryScreen": "画面キャプチャを再試行します",
    "screenFailed": "画面全体のキャプチャも開始できませんでした",
    "attemptFailed": "このキャプチャの試みはまだ開始できませんでした",
    "retryHint": "再度キャプチャする前に、ブラウザを完全に終了して再度開くか、最新の Edge / Chrome / Firefox を試してください。",
    "screenHint": "最小化したり他のウィンドウで覆ったりせずに、選択した画面を可能な限りゲームで埋めて表示されたままにします。接続後、レベルと経験値を確認してください。必要に応じて認識領域を調整します。",
    "more": "その他のトラブルシューティング手順",
    "windowMode": "ゲームをウィンドウ モードまたはボーダレス モードに切り替えて、ゲームを表示したままにします。",
    "factoryReset": "「設定」を開き、工場出荷時の設定に戻してから、ゲーム画面を再度接続してみてください。",
    "updateBrowser": "このブラウザを最新バージョンに更新してください。",
    "browser": "ブラウザを完全に終了して再度開くか、最新の Microsoft Edge / Google Chrome / Firefox を試してください。",
    "driver": "それでもキャプチャが失敗する場合は、コンピュータを再起動し、グラフィックス ドライバと Windows を更新します。録画、ストリーミング、またはリモート デスクトップ ツールが実行されている場合は、それらも閉じてみてください。",
    "compare": "メモ帳などの通常のウィンドウを試してください。ゲームのみが失敗する場合は、まずその表示モードを確認してください。すべてのソースが失敗した場合は、まずブラウザとシステムを確認してください。",
    "copy": "コピー診断",
    "copied": "診断がコピーされました",
    "copyFailed": "自動コピーに失敗しました。以下の診断を手動で選択してコピーします。",
    "diagnostic": "キャプチャ診断"
  },
  "appUpdate": {
    "eyebrow": "Maple Log · アップデート",
    "title": "アップデートの準備ができました",
    "hint": "更新して最新バージョンをお楽しみください。準備ができたら続行して更新してください。",
    "preview": "デザインのプレビュー · ページの更新なし",
    "previewFeedback": "プレビューのみ。更新は行われませんでした。",
    "previewClose": "カードはプレビュー中に表示されたままになります",
    "recordingHint": "更新が完了してこの記録が保存され、ページが更新されます。",
    "update": "更新して更新する",
    "endAndUpdate": "記録と更新を終了する",
    "later": "後で",
    "close": "30分後に思い出させて",
    "available": "利用可能なアップデート",
    "saving": "保存",
    "activating": "更新中",
    "blocked": "現在の操作が完了するまで待ってから更新してください。",
    "saveError": "保存が完了しませんでした。ページが更新されていません。データの保存と更新を再試行してください。",
    "activationError": "アップデートが完了しませんでした。ページが更新されていません。接続を確認して再試行してください。",
    "retry": "更新を再試行します"
  },
  "leaderboard": {
    "server": "サーバー",
    "mxdcServer": "中国クラシック",
    "gcwServer": "GCW 国際版",
    "uploadSourceRule": "ウィンドウ共有が必要です。タイトルは共有ごとに 1 回チェックされます。「{title}」とは明らかに異なるタイトルにより、記録全体が除外されます。タイトルバーなしの全画面キャプチャと未確認のタイトルはデフォルトで許可されています。ウィンドウを変更したり、全画面表示になったりしても、除外された記録は復元されません。ローカルの統計と履歴は影響を受けません。",
    "sourceNotice": {
      "capture-not-window": "この録画はランキングから除外されています。ウィンドウ共有が必要です。ローカル追跡は継続されます。ウィンドウを共有して新しい記録を開始すると、再度資格が得られます。",
      "capture-title-mismatch": "この録画はランキングから除外されています。ウィンドウ タイトルが一致しません。ローカル追跡は継続されます。対象のゲームを共有し、新しい記録を開始して再度資格を獲得します。"
    },
    "mapTip": {
      "details": "詳細",
      "openPage": "{name}のマップ情報を新しいタブで開きます",
      "open": "{name}のマップ情報を見る",
      "kind": "マップ",
      "loading": "マップ情報を読み込んでいます",
      "empty": "マップ情報がありません",
      "error": "マップ情報を読み込めませんでした。再試行してください。",
      "monsterCount": "モンスター",
      "npcCount": "NPC",
      "monsters": "このマップのモンスター",
      "npcs": "このマップのNPC",
      "description": "マップメモ",
      "noNpcs": "NPCはいません",
      "noMonsters": "モンスターなし",
      "more": "ほか {count} 件…",
      "image": "{name}のミニマップ",
      "noImage": "ミニマップは使用できません"
    },
    "title": "マップのランキングをレベリングする",
    "levelRange": "Lv. {start}–{end}",
    "levelSample": "この行は、{start} ～ {end} レベルの文字の記録を使用します。",
    "allLevels": "すべて",
    "minutes": "{count} 分",
    "sampleAccumulation": "同じマップ、同じレベル範囲、同じソースからのプレイヤーの記録は、1 つのサンプルに蓄積できます。全レベルランキングは、各レベル範囲を個別に計算して表示します。",
    "level": "レベル",
    "position": "ランク",
    "status": "ステータス",
    "collectingTab": "収集",
    "formalTab": "公式",
    "sourceFilter": "ソース",
    "hourlyExp": "経験値/時間",
    "hourlyReference": "参考 経験値/時間",
    "records": "{count} 記録",
    "sourceSamples": "データソース",
    "allSourcesShort": "すべて",
    "collapse": "詳細を折りたたむ",
    "closeDetails": "{name}の詳細を閉じる",
    "exp": "経験値 効率",
    "perHour": "経験値 / 時間",
    "typical": "ランキングの計算方法",
    "samples": "提供データ",
    "filters": "フィルター",
    "filterTitle": "フィルターマップ",
    "reset": "フィルターをリセットする",
    "done": "結果を見る",
    "search": "マップを検索する",
    "searchPlaceholder": "マップ名またはIDで検索",
    "searchClear": "検索をクリア",
    "filtersOpen": "フィルターを開く",
    "filtersCount": "{count} が選択されました",
    "removeFilter": "{label}を削除",
    "rules": "ランキングルール",
    "details": "マップの詳細",
    "openDetails": "{name}の詳細を見る",
    "scope": "{level} ・ {job} ・ {source}",
    "count": "{count} マップ",
    "page": "ページ {current} / {total}",
    "previous": "前のページへ",
    "next": "次のページ",
    "goToPage": "{page}のページへ",
    "scale": "このページの比較",
    "sorted": "ミドルペース順に並べる",
    "collecting": "データの収集",
    "moreUsers": "あと 1 人のプレイヤー | {count} より多くのプレイヤー",
    "moreMinutes": "あと 1 分 | {count}あと数分",
    "met": "会った",
    "usersProgress": "選手",
    "timeProgress": "有効時間",
    "sampleRule": "公式ランキングの要件",
    "uploadRule": "Maple Log アップロード要件",
    "uploadEligibility": "各セグメントには、同じマップ上および同じ 5 レベル範囲内で、{minutes} 分の有効な 経験値 データと正の 経験値 ゲインが必要です。個別のセグメントは結合されません。",
    "uploadTiming": "セッションを終了すると、対象となるセグメントが自動的にアップロードされます。一時停止または切断によって、すでに適格なセグメントが破棄されることはありません。",
    "qualificationHelp": "より多くのデータが必要なマップは、[収集中] の下に表示されます。",
    "distribution": "プレイヤー間での 経験値 レート",
    "source": "データソース",
    "updated": "最終更新日",
    "median": "ミドルペース",
    "low": "ペースを落とす",
    "high": "より速いペース",
    "upper": "速いペース",
    "medianHelp": "マップは、プレイヤー間で中央の 経験値/時間の結果によってランク付けされます。有効な記録のみがカウントされます。",
    "rangeHelp": "プレーヤーの約半数は、低速ペースと高速ペースの間に位置します。速いペースは上位10％付近だが、過去最高ではない。",
    "empty": "ここにはまだマップがありません",
    "emptyHint": "マップを検索するか、別のレベル範囲、職業、またはソースを選択してください。",
    "gcwEmptyHint": "マップを検索するか、別のレベル範囲を選択してください。",
    "error": "ランキングを読み込めませんでした",
    "refreshFailed": "更新に失敗しました。以前の結果も引き続き表示されます。",
    "reference": "基準効率",
    "pending": "ランキング更新待ち",
    "back": "リストに戻る",
    "closeDossier": "マップを閉じる関係書類",
    "dossier": "マップ関係書類",
    "identity": "マップ",
    "efficiency": "トレーニングのペース",
    "trust": "サンプルの信頼度",
    "monsters": "モンスター",
    "drops": "注目すべきドロップ",
    "equipment": "設備",
    "scroll": "巻物",
    "dropRateLabel": "ドロップ率 {rate}、{tier}",
    "dropRateTier": {"high": "相対的に高い", "medium": "相対的に中程度", "low": "相対的に低い", "neutral": ""},
    "dropRateValue": "ドロップ率 {rate}",
    "dropSources": "ドロップ元",
    "allDropMonsters": "すべてのモンスター",
    "dropMonsterFilter": "ドロップ元を絞り込む",
    "unknownDropRate": "不明",
    "noDropSources": "ドロップ元の情報がありません",
    "relativeDropRates": "色は現在の絞り込み内での相対的なドロップ率を表します。",
    "maxMonsterDropRate": "このマップのドロップ元のうち、判明している最大の確率です。キャラクターの補正は含みません。",
    "noMonsters": "このマップにはまだモンスター データがありません",
    "noDrops": "このマップではまだ確認されたドロップがありません",
    "noMapDetail": "このマップにはまだ関係書類がありません",
    "notes": "マップメモ",
    "loadingDetail": "マップの詳細をロードしています",
    "detailError": "マップの詳細を読み込めませんでした",
    "openBooklet": "小冊子で開く",
    "openBookletNamed": "小冊子 で {name} を開く",
    "spawn": "{count}",
    "monsterLevel": "Lv.{level}",
    "trustFormal": "{users} プレイヤー · {duration}",
    "trustUsersUnit": "選手",
    "hoursUnit": "時",
    "collectingNeed": "ほか {users} 人 · {time}",
    "selectMap": "{name}を表示",
    "moreFilters": "その他のフィルター",
    "partnership": "小冊子付き",
    "entityLoading": "詳細を読み込み中",
    "entityEmpty": "詳細はありません",
    "entityError": "詳細を読み込めませんでした",
    "entityKind": {
      "mob": "モンスター",
      "item": "アイテム"
    }
  },
  "app": {
    "name": "Maple Log",
    "tagline": "メイプルストーリー経験値計測",
    "localOnly": "ゲーム画面は端末内のみで処理",
    "currentPreset": "現在のプリセット",
    "primaryNav": "メインナビゲーション",
    "useDark": "ダークモードに切り替える",
    "useLight": "ライトモードに切り替える",
    "language": "表示言語",
    "install": "アプリをインストールする"
  },
  "startup": {
    "startingEngine": "認識エンジンの起動",
    "windowSelectedStage": "ゲームウィンドウが選択されました",
    "preparingRecognition": "認識を準備しています",
    "confirmingGameType": "ゲームの種類を確認しています",
    "gameDetectionFailures": {
      "dimensions-changed": "ゲームウィンドウのサイズが変更されました。サイズを固定して再試行してください。",
      "profile-changed": "認識設定が変更されました。認識を再起動して再試行してください。",
      "probe-error": "ゲームの種類を確認できませんでした。ゲーム画面全体を表示して再試行してください。"
    },
    "timeoutTitle": "認識エンジンの起動がタイムアウトしました",
    "timeoutHint": "認識エンジンの起動がタイムアウトしました。もう一度始めてみてください。選択したウィンドウは保持されます。",
    "sdkTimeoutHint": "認識プログラムのロードに時間がかかりすぎました。もう一度始めてみてください。それでも失敗する場合は、ページをリロードしてウィンドウを再度選択してください。",
    "retryEngine": "再起動",
    "copyDiagnostic": "コピー診断",
    "diagnosticCopied": "診断がコピーされました",
    "diagnosticCopyFailed": "自動コピーに失敗しました。以下の診断を手動でコピーします。",
    "diagnosticLabel": "起動診断",
    "stepWindow": "ゲーム画面接続",
    "stepWindowConnected": "接続済み",
    "stepWindowConnecting": "接続中...",
    "stepWindowSelected": "ウィンドウ選択済み",
    "stepModel": "認識モデル読み込み",
    "stepModelReady": "準備完了",
    "stepModelLoading": "読み込み中",
    "stepModelChecking": "キャッシュ確認",
    "stepEngine": "ローカルエンジン起動",
    "stepEngineStarting": "初期化中...",
    "stepEngineReady": "準備完了",
    "title": "画面認識の準備",
    "subtitle": "認識リソースがチェックされ、ロードされています。準備が完了すると、プレビューが自動的に開始されます。",
    "connectingSubtitle": "フレーム接続を完了します。次に認識リソースが自動的に準備されます。",
    "initializingTitle": "画面認識開始",
    "initializingSubtitle": "認識リソースの準備ができました。ローカルエンジンが始動中です。",
    "windowSelected": "ゲームウィンドウが選択されました",
    "windowConnected": "ゲームウィンドウが接続されました",
    "localProcessing": "このデバイスでは認識が維持されます",
    "engineLabel": "Maple Log 認識",
    "progress": "読み込みの進行状況",
    "cacheChecking": "このブラウザに既に保存されている認識リソースを確認しています",
    "cached": "{count}/2 認識リソースが準備完了",
    "localHint": "リソースは最初の使用時にロードされます。一度保存すると、今後の起動が速くなります。",
    "initializingLocalHint": "ウィンドウ権限は保持されます。ウィンドウを再度選択しなくても、起動を再試行できます。",
    "idle": "窓口待ち",
    "connectingFrame": "ゲーム画面の接続",
    "checking": "ローカルリソースを確認する",
    "detection": "画面の位置を準備しています",
    "recognition": "テキスト認識の準備",
    "prepared": "認識リソースの準備",
    "initializing": "認識エンジンの起動",
    "ready": "セットアップが完了しました",
    "phaseCheck": "リソースを確認する",
    "phaseRecognition": "認識の準備",
    "phaseReady": "起動を終了する",
    "errorTitle": "認識エンジンのセットアップに失敗しました",
    "errorStatus": "セットアップが不完全",
    "errorHint": "しばらくしてからもう一度お試しください。すでに準備されているリソースは再度取得されません。",
    "resourceErrorTitle": "認識リソースを読み込めませんでした",
    "resourceErrorHint": "認識リソースをダウンロードできませんでした。接続を確認して、もう一度試してください。IDM のダウンロード画面が表示された場合は、ブラウザーの IDM Integration Module 拡張機能を一時的に無効にしてから、再試行してください。IDM 本体を終了するだけでは解決しない場合があります。",
    "initializationErrorTitle": "認識エンジンを起動できませんでした",
    "initializationErrorHint": "ブラウザは画面認識を開始できませんでした。他の要求の厳しいタブを閉じて、もう一度試してください。",
    "simdErrorTitle": "このブラウザではローカル認識を実行できません",
    "simdErrorHint": "WASM SIMD は使用できません。最新のデスクトップ Edge、Chrome、Firefox を使用してください。このブラウザではリソースはダウンロードされません。",
    "insecure-contextErrorTitle": "このページは認識を安全に準備できません",
    "insecure-contextErrorHint": "ローカル認識には HTTPS が必要です。公式アドレスから Maple Log を開き、ゲーム ウィンドウに接続します。",
    "unknownErrorTitle": "読み込みが完了しませんでした",
    "unknownErrorHint": "予期せぬ事態により起動が中断されました。もう一度試してください。",
    "browserRecommendationTitle": "別のブラウザを試してください",
    "browserRecommendationHint": "再試行してもセットアップが失敗する場合は、最新の Microsoft Edge、Google Chrome、Firefox で Maple Log を再度開きます。",
    "fixesLabel": "その他試してみること",
    "factoryResetFixTitle": "「設定」で工場出荷時の設定を復元する",
    "factoryResetFixHint": "ローカルの調整と設定をクリアしてから、再度認識を準備します。",
    "factoryResetFixAction": "設定を開く",
    "updateBrowserFixTitle": "ブラウザを更新してください",
    "updateBrowserFixHint": "ブラウザの更新を確認してから、Maple Log を再度開きます。",
    "cacheDegradedWarning": "今のところ認識は機能しますが、リソースを保存できなかったため、次回再度ロードする必要がある可能性があります。",
    "retry": "もう一度試してください",
    "continue": "一旦閉じます"
  },
  "nav": {
    "security": "安全性レポート",
    "securityBadge": "公開",
    "securityShort": "安全性",
    "dashboard": "ダッシュボード",
    "live": "リアルタイム記録",
    "calibration": "認識位置の調整",
    "history": "履歴",
    "rank": "狩場ランキング",
    "rankShort": "狩場ランキング",
    "rankPartner": "小冊子とのコラボレーション",
    "settings": "設定",
    "changelog": "更新履歴",
    "about": "Maple Log について"
  },
  "common": {
    "unavailable": "該当なし",
    "save": "保存",
    "cancel": "キャンセル",
    "reset": "リセット",
    "close": "閉じる",
    "retry": "再試行",
    "unknown": "不明",
    "confirm": "確認する"
  },
  "journey": {
    "efficiency": "区間効率",
    "recentEfficiency": "最近の5分",
    "pathSummary": "重要な瞬間",
    "pathValue": "{levels} レベルアップ · {maps} マップ",
    "summaryLabel": "区間効率の概要",
    "level": "レベル",
    "expProgress": "現在の経験値",
    "map": "マップ",
    "approximate": "クロスレベル推定",
    "confirmedPoint": "確認されたエンドポイント",
    "awaitingReading": "新しい正確な測定値を待っています",
    "approximateHint": "クロスレベル 経験値 は、この記録中に推測されたレベル要件を使用します",
    "confirmedHint": "検証済みの正確な 経験値 読み取り値から",
    "efficiencyChartLabel": "クロック時間別の区間効率チャート",
    "eventsLabel": "重要な瞬間",
    "eventLevelUp": "Lv.{level}到達",
    "eventMapChange": "{map}を入力しました",
    "mapChanged": "マップが変更されました",
    "minuteShort": "メートル",
    "hourShort": "h",
    "perHourShort": "/時間",
    "chartControls": "チャートコントロール",
    "selectRange": "選択してズームする",
    "panChart": "パン時間範囲",
    "zoomIn": "ズームイン",
    "zoomOut": "ズームアウト",
    "resetZoom": "ズームをリセットする",
    "earlier": "前期",
    "later": "後期",
    "eventGroup": "{time} · {count} イベント",
    "event": {
      "pause": "記録が一時停止されました",
      "resume": "記録再開",
      "capture-interrupted": "キャプチャが中断されました",
      "capture-restored": "キャプチャが復元されました",
      "rebaseline": "経験値 読み取り値が再調整されました"
    }
  },
  "presets": {
    "worlds": { "name": "メイプルストーリーワールド", "description": "メイプルストーリーワールドの繁体字中国語UI" },
    "label": "ゲームプリセット",
    "auto": "自動 (クラシック / Artale)",
    "gcw": { "name": "GCW", "description": "GCW 英語インターフェース" },
    "artale": {
      "name": "Artale",
      "description": "Artale 繁体字中国語インターフェース"
    },
    "ambiguous": "複数のゲーム インターフェイスが見つかりました。ゲーム ウィンドウを 1 つだけ表示したままにして、自動認識を再試行してください。",
    "mxdc": {
      "name": "中国クラシックサーバー",
      "description": "中国クラシックサーバーインターフェース"
    }
  },
  "live": {
    "expNetGain": "純増経験値",
    "expNetShort": "純増",
    "mesosLocate": {
      "inventoryOpen": "インベントリは開いていますか?",
      "start": "自動検出",
      "retry": "再検出",
      "retrySave": "保存を再試行",
      "recognizing": "検出中…",
      "saving": "保存中…",
      "locating": "インベントリと メル 残高を常に表示できるようにします。",
      "located": "メル エリアが見つかりました。残高を読み取っています…",
      "missing": "メル が見つかりません。インベントリを開いて残高を表示したままにしてから、もう一度お試しください。",
      "timeout": "検出がタイムアウトしました。ゲームを表示したままにして、もう一度試してください。",
      "saveFailed": "メル 領域を保存できませんでした。もう一度試してください。",
      "failed": "メル 検出は使用できません。後でもう一度試してください。",
      "interrupted": "キャプチャまたは認識の設定が変更されました。再度検出してください。",
      "disconnected": "ゲーム ウィンドウに接続し、インベントリを開いて、メル 残高を読み取ります。",
      "connecting": "ゲームウィンドウを接続しています。検出は間もなく利用可能になります。",
      "preparing": "認識を準備しています。検出は間もなく利用可能になります。",
      "engineError": "認識できません。このページの指示に従って再試行してください。",
      "otherCalibration": "別のキャリブレーションが進行中です。しばらくしてからもう一度お試しください。",
      "unavailable": "記録または設定を処理しています。しばらくしてからもう一度お試しください。"
    },
    "empty": {
      "expPreviewHint": "記録を開始すると、平均・リアルタイム効率とレベルアップ予測を表示します。",
      "expTitle": "経験値データ",
      "expHint": "接続して 経験値 の進行状況を確認します。レベリング効率を測定するために記録を開始します。",
      "expConnectedHint": "レベルと 経験値 を表示しておいてください。ここに測定値が表示されます。",
      "mesosTitle": "メルデータ",
      "mesosHint": "接続してインベントリを開いて、メル の残高を確認します。",
      "mesosConnectedHint": "インベントリを開いて、メル 残高を表示しておいてください。",
      "resourcesTitle": "キャラクターステータス",
      "resourcesHint": "接続して健康状態とマナを確認してください。",
      "resourcesConnectedHint": "HPとMPを表示しておきます。測定値は自動的に表示されます。",
      "resourcesLabel": "HP / MP · BUFF通知",
      "reading": "まだ読んでいません",
      "maximum": "最大{value}",
      "startToCalculate": "計算のための記録を開始します",
      "waitingRate": "レートデータの準備ができていません",
      "cannotEstimate": "まだ見積もりができません",
      "connecting": "ゲーム画面を接続します。接続すると読み取りが開始されます。",
      "preparing": "認識を準備しています。読み取りが自動的に開始されます。",
      "readingError": "認識できません。ページの指示に従って再試行してください。",
      "reconnect": "ゲーム画面は使用できません。上記の手順に従って再接続してください。",
      "trendTitle": "レベリング効率チャート",
      "trendHint": "記録を開始して、時間の経過とともに効率がどのように変化するかを確認します。",
      "trendPending": "トレンドデータの収集",
      "trendPendingHint": "位相データが利用可能な場合、トレンドが表示されます。",
      "diagnosticsTitle": "接続してステータスを表示",
      "diagnosticsHint": "接続したら、ここでフレーム認識とデータ更新を確認します。"
    },
    "title": "ダッシュボード",
    "subtitle": "狩りの効率を計測。ゲーム画面はこの端末内のみで処理します。",
    "selectWindow": "ゲームウィンドウを選択してください",
    "captureIdle": "ゲームウィンドウを待っています",
    "captureHint": "ブラウザは、実行中の メイプルストーリー ウィンドウを選択するように求めます。",
    "firstStep": "ステップ1",
    "onboardingTitle": "メイプルストーリー ウィンドウを選択してください",
    "onboardingHint": "Maple Log は、明示的に選択したウィンドウのみを読み取ります。接続したらデータを確認し、記録を開始します。",
    "gettingStarted": "はじめに",
    "guideWindow": "ゲームウィンドウを選択してください",
    "guideCheck": "必要に応じて校正する",
    "guideRecord": "記録を開始",
    "calibrationShortcut": "認識範囲を調整",
    "calibrationShort": "調整",
    "capturePermissionDenied": "ウィンドウ共有権限が付与されていませんでした。もう一度ゲーム ウィンドウを選択します。共有ダイアログが表示されない場合は、ブラウザがプロンプトをブロックしていないかどうかを確認してください。",
    "captureSourceUnavailable": "選択したキャプチャを開始できませんでした。以下の別のキャプチャ方法をお試しください。",
    "captureTimeout": "ゲーム画面への接続がタイムアウトしました。ゲームウィンドウを表示したままにして、再度選択します。",
    "captureUnsupported": "このブラウザはウィンドウをキャプチャできません。最新の Microsoft Edge、Google Chrome、Firefox を使用してください。",
    "captureFailed": "ゲームウィンドウに接続できませんでした。もう一度選択して再試行してください。",
    "captureRequesting": "接続中",
    "captureSelecting": "ソースの選択",
    "captureConnecting": "連結フレーム",
    "captureSelectingTitle": "ブラウザダイアログでキャプチャソースを選択します",
    "captureConnectingTitle": "選択したフレームを接続する",
    "captureRetryWindow": "ウィンドウを再度選択してください",
    "captureSelectionSlow": "このフレームの選択または接続には、通常よりも時間がかかりました。ピッカーの動作が遅い場合は、録画、ストリーミング、およびリモート デスクトップ ツールを閉じ、開いているウィンドウを減らし、ブラウザとグラフィック ドライバーを更新します。",
    "captureIssueSourceTitle": "ゲーム画面を開始できませんでした",
    "captureIssueSourceHint": "ブラウザは選択されたキャプチャを開始できませんでした。画面全体をキャプチャしてみてください。",
    "captureIssueTimeoutTitle": "ゲーム画面への接続がタイムアウトしました",
    "captureIssueTimeoutHint": "ブラウザは選択されたキャプチャを時間内に受信できませんでした。ゲームを表示したままにするか、画面全体をキャプチャしてみてください。",
    "captureIssueUnsupportedTitle": "ウィンドウキャプチャはサポートされていません",
    "captureIssueUnsupportedHint": "最新の Microsoft Edge、Google Chrome、Firefox で Maple Log を開きます。",
    "captureIssueUnknownTitle": "ゲームウィンドウに接続できませんでした",
    "captureIssueUnknownHint": "もう一度ゲーム ウィンドウを選択します。それでも失敗する場合は、以下の回復手順を試してください。",
    "captureRecoveryMore": "まだ接続できませんか?不要なウィンドウを閉じて、ブラウザとグラフィックス ドライバーを更新します。ブラウザを完全に終了するか、Win + Ctrl + Shift + B を押すか、最新の Edge / Chrome / Firefox を試すこともできます。",
    "captureActive": "ウィンドウが接続されました",
    "captureInterrupted": "キャプチャが中断されました",
    "start": "記録開始",
    "pause": "一時停止",
    "resume": "再開",
    "end": "記録終了",
    "ending": "終了処理中",
    "startConfirming": "経験値を確認中",
    "startBaselineFailed": "現在のレベルと経験値が確認できませんでした。 経験値 領域全体が表示されていることを確認してから、再試行してください。",
    "startBaselineSlow": "認識の反応が遅いです。ゲームを表示したままにして、もう一度試してください。",
    "startBaselineConfirming": "レベルと経験値はまだ確認中です。フレームを安定させたままにして、もう一度お試しください。",
    "startBaselineIncomplete": "経験値 の完全な値は確認できませんでした。 経験値 の数値とパーセンテージの両方を表示したままにして、再試行してください。",
    "startBaselineCaptureUnavailable": "ゲーム画面が中断されました。ゲームウィンドウを再度選択して、再試行してください。",
    "startWaitingFrame": "次のフレームを待っています",
    "startRecognizing": "レベルと経験値を読み取り中",
    "startFrameSlowTitle": "ゲーム画面の到着が遅い",
    "startFrameSlowHint": "予想されたサンプリング ウィンドウ内に新しいフレームが到着しませんでした。共有ウィンドウを表示したままにするか、キャンセルして再試行してください。",
    "startIssue": {
      "waitingEyebrow": "記録の準備中",
      "confirmationLabel": "{metric}の確認",
      "eyebrow": "記録前に必要なアクション",
      "levelTitle": "現在のレベルは確認されていません",
      "expTitle": "完全な経験値は未確認",
      "slowTitle": "認識の反応が遅い",
      "slowWaitingTitle": "この端末では認識が遅くなります",
      "slowWaitingReason": "信頼できる経験値の開始値を確認中です。確認後に計測を開始し、レベルなどの情報は後から補います。再度開始する必要はありません。",
      "expOneMore": "経験値は認識されました。もう 1 つ確認が必要です (1/2)。ゲームを目に見える状態に保ちます。",
      "confirmationProgress": "{metric}の確認：{confirmed} / {target}",
      "details": "認識の詳細",
      "refreshDetails": "詳細を更新",
      "noSnapshot": "認識時の画像はまだありません。後でもう一度詳細を更新してください。",
      "expProgressRetained": "完全な経験値の確認を1回分保持しています（1/2）。別の映像フレームから完全な読み取りがもう1回必要です。",
      "engineTitle": "経験値を読み取れません",
      "captureTitle": "ゲーム画面が中断されました",
      "detectedText": "この試みの OCR テキスト",
      "levelConfirming": "レベル {candidate} が読み取られましたが、2 回目の独立した確認がまだ必要です。",
      "reasons": {
        "no-text": "実際の読み取り領域ではテキストが検出されませんでした。フレームを確認し、ゲーム UI を表示したままにします。",
        "parse-failed": "テキストが検出されましたが、有効な {metric} データとして解析できませんでした。",
        "low-confidence": "{metric} テキストが検出されましたが、その品質が厳密な確認しきい値を満たしていませんでした。",
        "mixed-content": "枠内にLV周りに別の数字や邪魔な内容が含まれていてレベルが曖昧。",
        "confirming": "候補 {metric} 値が読み取られましたが、独立したサンプルの確認が完了していません。",
        "incomplete": "経験値 の絶対値またはパーセンテージは不完全であるため、正確な開始点として使用できません。",
        "conflict": "経験値 の数値とパーセンテージは、同じフレームのバーに対して検証できませんでした。",
        "slow": "認識がまだ遅いフレームを処理しているため、新しい信頼できるレベルと 経験値 のペアはまだ到着していません。",
        "unresponsive": "専用の確認は進まず、認識タスクは依然として返されません。ゲームを表示したままにして、再試行してください。",
        "engine-error": "経験値の読み取りに失敗し、確認を停止しました。再試行してください。解消しない場合はゲームウィンドウを再接続してください。",
        "capture-unavailable": "ゲーム画面または共有許可が中断されたため、正確な開始点をキャプチャできません。"
      },
      "reviewFailure": {
        "no-text": "最新のレビューではテキストが見つかりませんでした。認識されたレベル候補は引き続き保持されます。",
        "parse-failed": "最新のレビューでは有効なレベルを解析できませんでした。認識された候補は引き続き保持されます。",
        "low-confidence": "最新のレビューは品質の基準を下回っていました。認識された候補は引き続き保持されます。"
      },
      "path": {
        "legacy": "この試みでは、元の認識領域が使用されました",
        "adaptive": "この試みでは、自動的に適応されたエリアが使用されました"
      },
      "guidance": {
        "level": "レベル数字全体と少しの余白を含めてください（オレンジ色のバッジ、または暗い背景の黄色い数字）。数字や端を切り取ったり、キャラクター名、職業、その他の番号を含めたりしないでください。",
        "exp": "経験値 の完全な数値とパーセントのテキストを含めます。黄色のバーは範囲内にある必要はありません。"
      },
      "adjust": {
        "level": "レベルエリアの調整",
        "exp": "経験値エリアを調整"
      },
      "chooseWindow": "ウィンドウを再度選択してください",
      "retry": "再認識",
      "cancel": "キャンセル確認",
      "later": "後で"
    },
    "pip": "ウィジェットを開く",
    "pipUnsupported": "ドキュメントのピクチャー・イン・ピクチャーは使用できません",
    "elapsed": "記録時間",
    "expRate": "経験値 / 時間",
    "mesosRate": "メル / 時間",
    "level": "レベル",
    "exp": "経験値",
    "mesos": "メル",
    "hp": "HP",
    "mp": "MP",
    "mapName": "現在のマップ",
    "jobName": "職業",
    "mapPending": "マップ認識中",
    "mapUncertain": "マップ未確認",
    "mapConfirming": "マップ確認中",
    "currentRecord": "現在の記録",
    "recentTrend": "経験値効率の推移",
    "noData": "記録を開始すると、区間ごとの経験値効率が表示されます。",
    "trendChartLabel": "今回の記録の区間効率",
    "modelReady": "OCR リソースが準備されており、画像が変更された場合にのみ認識が実行されます。",
    "modelLoading": "OCR リソースを初期化しています。",
    "modelError": "OCR リソースが利用できません。続行するにはリロードしてください。",
    "diagnostics": "認識状況",
    "levelPending": "レベル未取得",
    "coverageShort": "適用範囲",
    "coverageHint": "この記録内の最初の信頼できる読み取り値から開始します。欠落データと再利用されたキャッシュは除外されますが、後で検証された更新によってレートが決まります。",
    "expProgress": "現在の経験値",
    "startExp": "開始時の経験値",
    "startLevel": "開始Lv.{level}",
    "remainingExp": "次のレベルへ",
    "levelEta": "レベルアップまで",
    "fullLevelDuration": "1レベルに必要な時間",
    "expGained": "今回の獲得経験値",
    "startSummary": "開始Lv.{level}・{exp} 経験値",
    "expConfirmationFailure": {
      "invalid-exp-range": "経験値 の数値とパーセンテージが読み取られましたが、この読み取りは整合性チェックに失敗したため、確認にカウントできません。",
      "incompatible-exp-samples": "2 つの 経験値 読み取り値を相互に検証できませんでした。別の確認が必要です。"
    },
    "readyToLevel": "レベルアップの準備完了",
    "lessThanMinute": "1分以内",
    "estimateMinutes": "{count} 分",
    "estimateHours": "{hours} 時間 {minutes} 分",
    "estimateDays": "{days}日 {hours}時間",
    "inventoryRecognition": "所持メルと収支",
    "startMesos": "開始時の所持メル",
    "currentMesos": "現在の所持メル",
    "balanceMesos": "所持メルの増減",
    "netMesos": "記録中の純増メル",
    "showBalanceComparison": "開始残高と残高変更を表示",
    "showTrackedMesos": "現在の残高と追跡された純額を表示します",
    "disableRecognition": "認識しない",
    "disableMetricRecognition": "{metric}の認識を停止します",
    "restoreDefaultRecognition": "認識を再開する",
    "hideCard": "カードを非表示",
    "mesosUnavailableHint": "インベントリを開き、メル エリアを表示したままにします。最初に信頼できる残高が開始残高となります。",
    "mesosAvailableHint": "記録中の純増メルは、インベントリが表示されている間に確認できた変化のみを累計します。現在残高と開始残高の差とは異なる場合があります。",
    "resourceStatus": "現在の状況",
    "located": "位置が見つかりました",
    "presetPosition": "デフォルトの位置を使用する",
    "processingLatency": "更新速度",
    "retrying": "再試行保留中",
    "onDemand": "画面による更新",
    "gameLayout": "データ位置",
    "dataRefresh": "データ更新",
    "textReading": "テキストの読み取り",
    "windowConnection": "ゲームウィンドウ",
    "refreshWaiting": "フレームを待っています",
    "refreshSmooth": "スムーズ",
    "refreshNormal": "ノーマル",
    "refreshSlow": "少し遅い",
    "ready": "準備完了",
    "preparing": "準備中",
    "ocrWaitingForWindow": "接続後起動",
    "unavailable": "利用不可",
    "connected": "接続済み",
    "notConnected": "接続されていません",
    "status": {
      "ending": "終了処理中",
      "idle": "開始されていません",
      "running": "記録",
      "paused": "一時停止中",
      "ended": "終了しました",
      "interrupted": "接続が失われました"
    }
  },
  "calibration": {
    "pendingRawText": "認識結果はまだありません",
    "ocrInputPreview": "実際の OCR 入力",
    "liveRegionPreview": "選択範囲のライブ表示",
    "waitingFrame": "新しいフレーム待ち",
    "mesosQueued": "OCR 待ち",
    "taskScheduled": "処理開始時刻",
    "taskCompleted": "処理完了時刻",
    "completedStatus": "直近の処理結果",
    "autoLocate": "自動認識",
    "autoDialog": {
      "details": "位置診断",
      "download": "キャプチャした画像をダウンロードする",
      "copy": "コピー診断",
      "copied": "診断がコピーされました",
      "exportFailed": "エクスポートに失敗しました。再試行してください。",
      "capture": "キャプチャサイズ",
      "scale": "UIスケール",
      "duration": "検索期間",
      "confirmation": "確認",
      "confirmations": {
        "source-frames": "個別のソースフレーム",
        "static-structure": "静的構造の検証"
      },
      "reasons": {
        "timeout": "認識がタイムアウトしました。再試行してください。",
        "not-found": "UI構造が見つかりません。ゲーム全体を表示します。",
        "too-small": "画像が小さすぎるか、不鮮明です。ゲームを拡大します。",
        "occluded": "不完全な領域構造。カバーされるかもしれません。",
        "multiple-scenes": "複数のゲーム ビューが検出されました。キャプチャ範囲を狭くします。",
        "unconfirmed": "候補は見つかりましたが、確認が不完全です。",
        "capture-interrupted": "キャプチャが中断されました。キャプチャを再開して再試行します。"
      },
      "stages": {
        "preparing": "準備中",
        "locating": "領域の位置を特定する",
        "saving": "ポジションの保存",
        "ended": "完了しました"
      },
      "count": "{count}/{total} にあります",
      "items": {
        "waiting": "待っています",
        "confirming": "確認中",
        "located": "位置",
        "saved": "保存されました",
        "missing": "見つかりません"
      },
      "mesosMissing": "メル が見つかりません。インベントリを開き、メル 領域を表示したままにして、再試行してください。",
      "retryMesos": "メルを再試行してください",
      "recognizing": "認識中…",
      "keepInventoryVisible": "インベントリと メル エリアを表示したままにします。",
      "retained": "以前のポジションが保持される",
      "cancel": "キャンセル",
      "done": "完了",
      "retry": "全てを再認識する",
      "retrySave": "保存を再試行",
      "keepVisible": "領域が確認されている間、ゲームを表示したままにします。",
      "outcomes": {
        "complete": "すべての {total} 位置が特定され、保存されました。",
        "partial": "{count} の位置が保存されました。残りの領域の検索を再試行します。",
        "failed": "リージョンが見つかりませんでした。キャプチャを表示したままにして、再試行してください。",
        "saveFailed": "位置は見つかりましたが保存されていません。保存を再試行してください。",
        "cancelled": "キャンセル。既存のポジションは置き換えられませんでした。"
      }
    },
    "resetAllConfirmTitle": "すべてのデフォルト位置を復元する",
    "resetAllConfirmMessage": "7 つの項目すべてをデフォルトの位置に戻しますか?これにより、手動での位置調整がクリアされます。",
    "resetAllConfirm": "デフォルトに戻す",
    "resetAllCancel": "キャンセル",
    "resetAllSuccess": "7 項目すべてのデフォルト位置が復元されました。",
    "recognitionResult": "認識結果",
    "emptyRawText": "まだテキストが読まれていません",
    "awaitingRegionRawText": "エリアを確認してから読み取ります",
    "expandRawText": "テキストを展開する",
    "collapseRawText": "テキストを折りたたむ",
    "regionPreview": "領域のプレビュー",
    "recognitionDetails": "認識の詳細",
    "resultStates": {
      "waiting": "認識を待っています",
      "preparing": "認識の準備中",
      "restoring": "デフォルトの復元",
      "disconnected": "捕獲を待っています",
      "disabled": "認識オフ",
      "running": "更新中",
      "confirming": "確認中",
      "success": "認識されました",
      "partial": "部分的に認められる",
      "failed": "まだ認識されていません",
      "hidden": "メル エリア非表示",
      "engineError": "認識できません"
    },
    "resultLabels": {
      "current": "現在の結果",
      "candidate": "結果は確認待ちです",
      "previous": "前回の読書"
    },
    "resultHints": {
      "mapTextClipped": "マップのテキストが切り取られる場合があります。フルネームを少し余白を残して入力してください。",
      "mapSuffixUncertain": "終了番号はまだ不明です。数値全体が表示されていることを確認してください。認識は自動的に再試行されます。",
      "mapUncertain": "完全なマップ名は確認できませんでした。自動的に再試行します。最後に確認されたマップは、利用可能な場合には保持されます。",
      "mapSuffixClipped": "マップ番号が切り取られる場合があります。フレーム内にフルネームとその接尾辞を含めます。",
      "mapSuffixPending": "マップ番号を確認します。最後に確認されたマップが利用可能な場合は保持されます。",
      "layoutUnavailable": "有効なレイアウト アンカーがありません。移転;ゲームを目に見える状態に保ちます。",
      "resourceBarConflict": "テキストとバーが一致しません。正確な数字は受け入れられていません。",
      "newPosition": "位置調整済み。新しいエリアからの読み取りを待っています。",
      "locating": "読み取りエリアの位置を特定します。ゲームを目に見える状態に保ちます。",
      "openInventory": "インベントリを開き、メル エリアを表示したままにします。",
      "inventoryUnconfirmed": "メル欄を確認できません。再検出中です。インベントリ全体を表示したままにしてください。",
      "noText": "テキストが検出されませんでした。読みたい内容に枠を合わせます。",
      "parseFailed": "テキストを解析できませんでした。フレームを狭くして、他のコンテンツを除外します。",
      "lowConfidence": "テキストが不明瞭です。読み込み枠とゲーム画像を確認してください。",
      "noResult": "まだ結果はありません。読み取りエリアをすっきりと見えるようにしてください。",
      "partial": "いくつかの情報が読み取られました。完全な数はまだ確認されていません。",
      "estimated": "これは推定値です。正確な数字を待っています。",
      "engineError": "認識エンジンの準備ができていません。ダッシュボードで認識リソースを確認します。"
    },
    "statisticsReview": "統計の検証",
    "statisticsReason": "統計検証の理由",
    "mapConfirmationReason": "検討理由",
    "statisticsStates": {
      "accepted": "統計検証に合格しました",
      "pending": "調査中の統計",
      "rejected": "今回は使用しませんでした"
    },
    "initialize": "すべてデフォルトに戻す",
    "initializing": "復元中…",
    "restoreMetricHint": "{metric} のみデフォルトの位置を復元します",
    "initializingHint": "領域の位置を確認します。ゲームを目に見える状態に保ちます。",
    "initializeComplete": "7 つのリージョンすべてがデフォルトに復元され、保存されました。",
    "initializePartial": "{count} 領域を保存しました。 {metrics} が見つかりませんでした。このレイアウトの既存の位置は保持されました。完全な UI を表示して再試行してください。",
    "initializeFailed": "デフォルトの復元または保存が完了しませんでした。キャプチャを表示したままにして、再試行してください。",
    "mapConfirmationWait": "レビュー待ち",
    "mapConfirmationSeconds": "{count} 秒",
    "mapConfirmationMethod": "確認方法",
    "mapConfirmationModes": {
      "independent-frames": "独立した2フレームで再確認",
      "suffix-frames": "独立したフレームでサフィックスが検証される",
      "cross-variant": "一致するバリアント",
      "stable-variant": "安定した繰り返し読み取り値"
    },
    "mapConfirmationReasons": {
      "suffix-ambiguous": "マップ番号は不明です。別のフレームを待っています",
      "suffix-clipped": "マップ番号が切り取られる場合があります。読み取り領域を確認してください",
      "collecting": "より多くの独立したフレームを待っています",
      "conflict": "異形は同意しません。安定性の比較",
      "unstable": "十分に安定した結果はありません。後で再試行します",
      "expired": "レビューがタイムアウトしました。確認できません。自動的に再試行します"
    },
    "title": "認識位置の調整",
    "subtitle": "読み取る領域を枠で囲みます。調整はこのブラウザに自動的に保存されます",
    "noCapture": "ダッシュボードに戻り、最初にゲーム ウィンドウを選択します",
    "goLive": "ダッシュボードに戻る",
    "autoLocated": "自動的に見つかります",
    "fallback": "デフォルトの位置を使用する",
    "confidence": "読み取り品質",
    "selectedRoi": "データ項目",
    "expCreditedDelta": "信頼できる 経験値 がこのサンプルにクレジットを提供しました",
    "expThreshold": "信頼できるゲイン制限",
    "expDisplayValue": "経験値 エンドポイントが表示されました",
    "expDisplayGain": "表示された純利益",
    "expDisplayStatus": "計算状況の表示",
    "expDisplayStates": {
      "ready": "利用可能",
      "stale": "新たな読み物を待っています",
      "pending-transition": "確認中",
      "unresolved-level": "不完全な経験値データ",
      "unavailable": "完全な読み取りはありません"
    },
    "expAdmissionReasons": {
      "large-gain": "ゲインが制限を超えています。除外されたギャップ",
      "level-correction": "レベル補正;レベルアップは確認されていない",
      "decrease": "経験値 減少しました。ベースラインのレビュー",
      "requirement-conflict": "レベル要件が矛盾しています",
      "recovery": "回復後のレビュー",
      "invalid": "無効な経験値データ",
      "stale": "繰り返されたサンプルまたは古いサンプル"
    },
    "preview": "読書プレビュー",
    "latestRecognition": "最新の認識",
    "statisticsValue": "統計に使用される",
    "confirmationProgress": "{current}/{target} のレビュー",
    "rawText": "OCRテキスト",
    "barRatio": "流動比率",
    "readingStatus": "読み取りステータス",
    "lastAttempt": "最後の試み",
    "inferenceDuration": "推論時間",
    "durationValue": "{value} ミリ秒",
    "enhancement": "強化",
    "enhancementValue": "バリアント {index}",
    "levelEnhancements": {
      "color-smooth": "カラー・滑らか",
      "color-pixelated": "カラー・最近隣",
      "luminance-inverted": "輝度反転・滑らか",
      "luminance-smooth": "輝度・滑らか",
      "luminance-pixelated": "輝度・最近隣"
    },
    "failureReasonLabel": "拒否された理由",
    "levelCorrected": "連続読み取りでレベルを確認",
    "profile": "現在のフレーム",
    "saved": "キャリブレーションが保存されました",
    "strategy": "読み取り方法",
    "sourcePreview": "元のビュー",
    "processedPreview": "強化されたビュー",
    "captureInfo": "フレーム詳細",
    "help": "テキストボックスを移動またはサイズ変更します。色付きの HP、MP、および 経験値 バーは、検索されたトラックから自動的にチェックされるため、テキスト フレーム内にある必要はありません。",
    "required": "プリセットが更新されました。認識領域を確認します。現在の設定は自動的に保存されます。",
    "recommendedHint": "破線の輪郭はテキスト読み取り領域です。細い実線の輪郭は自動チェックされたカラー バーであり、OCR には送信されません。",
    "adjustedHint": "テキスト範囲は自動的に保存されました。",
    "restoreDefault": "デフォルトに戻す",
    "startGuidanceTitle": "記録できなかった領域を修正する",
    "startGuidance": {
      "level": "レベルは確実に確認されていません。以下の例を使用して破線のテキスト範囲を調整し、2 つの独立した読み取り値に対してフレームを固定したままにします。",
      "exp": "完全な 経験値 は確実に確認されていません。以下に示すように、フレーム 経験値、現在の値、およびパーセンテージ。黄色のバーが自動的にチェックされます。"
    },
    "resize": "認識領域のサイズを変更する",
    "roiLabel": "選択された認識領域",
    "overrides": "{count} カスタム領域",
    "strategyType": {
      "bar": "バー検出",
      "ocr": "テキスト認識",
      "fused": "クロスチェック済み",
      "unavailable": "利用不可"
    },
    "positioning": "ポジションステータス",
    "customPosition": "ユーザーが調整した",
    "automaticPosition": "推奨範囲",
    "adaptiveSearching": "適応する",
    "adaptiveReady": "自動的に絞り込まれます",
    "adaptiveFallback": "検索範囲を使用する",
    "searchRange": "検索範囲",
    "actualTextRange": "読んだテキスト",
    "actualBarRange": "バーの読み取り",
    "framingGuide": "額装例",
    "include": "含める",
    "exclude": "除外する",
    "guideSamples": {
      "nickname": "キャラクター名",
      "job": "職業名",
      "jobValue": "暗殺者",
      "minimap": "ミニマップ",
      "mapName": "森の狩猟場",
      "quest": "クエストテキスト"
    },
    "guide": {
      "level": {
        "title": "読み取り専用LVとレベル番号",
        "include": "レベル数字全体（オレンジ色のバッジ、または暗い背景の黄色い数字）と少しの余白",
        "exclude": "名前、職業、ギルド、その他の番号"
      },
      "exp": {
        "title": "経験値 テキスト行のみをフレーム化します",
        "include": "経験値、現在の値、およびパーセンテージ",
        "exclude": "下の黄色のバーとレベル、HP、MP、および隣接するテキスト"
      },
      "hp": {
        "title": "HP番号行のみをフレーム化",
        "include": "HPラベルと現在/最大値",
        "exclude": "下の赤いバー、MP、経験値、および隣接するステータス テキスト"
      },
      "mp": {
        "title": "MP番号行のみをフレーム化",
        "include": "MP ラベルと現在値/最大値",
        "exclude": "下の青いバー、HP、経験値、および隣接するステータス テキスト"
      },
      "mesos": {
        "title": "メル 残高行全体を読む",
        "include": "メル アイコンとフルバランス",
        "manualInclude": "メルの残高全体（数字だけを囲んでも構いません）",
        "exclude": "商品数、価格、その他の数値"
      },
      "mapName": {
        "title": "現在のマップ名のみを読み取ります",
        "include": "完全なマップ名のテキスト",
        "exclude": "ミニマップのコンテンツ、チャンネル、クエストのプロンプト"
      },
      "jobName": {
        "title": "職業名のみを読み取ります",
        "include": "レベルの上下にある完全な職業名",
        "exclude": "左がレベル、下がキャラクター名"
      }
    },
    "unsaved": "未保存の変更",
    "savedState": "変更が保存されました",
    "autoSaving": "自動保存",
    "autoSaved": "自動的に保存されました",
    "autoSaveError": "自動保存に失敗しました",
    "autoSaveErrorHint": "キャリブレーション位置が保存されませんでした。再度調整して再試行してください。",
    "fineTune": "細かい位置制御",
    "moveUp": "上に移動",
    "moveDown": "下に移動",
    "moveLeft": "左に移動",
    "moveRight": "右に移動",
    "shrink": "認識領域の縮小",
    "expand": "認識領域を拡大する",
    "status": {
      "disabled": "認識オフ",
      "queued": "実行を待っています",
      "running": "推論の実行",
      "ready": "確認済み",
      "confirming": "候補者の検討中",
      "source-hidden": "メル エリアを表示したままにする",
      "no-result": "まだ何も読まれていません",
      "no-text": "テキストが検出されませんでした",
      "parse-failed": "テキストを解析できませんでした",
      "low-confidence": "信頼度が低すぎる",
      "corrected": "修正しました"
    },
    "failureReasons": {
      "capture-unavailable": "ゲーム画面のキャプチャが停止中、または利用できません",
      "ocr-timeout": "OCR がタイムアウトしました。再試行しています",
      "ambiguous-exp": "経験値の項目境界が不明確です。再認識しています",
      "layout-unavailable": "有効なレイアウトアンカーがありません",
      "resource-bar-conflict": "テキストとバーの値が一致しない",
      "no-text": "選択した領域でテキストが検出されませんでした",
      "parse-failed": "テキストは見つかりましたが、有効なデータとして解析できませんでした",
      "low-confidence": "信頼度が現在の厳密性設定を下回っていました"
    }
  },
  "history": {
    "unknownMap": "未知のマップ",
    "phaseEfficiency": "区間効率",
    "title": "履歴",
    "subtitle": "すべての記録の主要な概要はこのデバイスに保存されます",
    "count": "{count} 記録",
    "empty": "完了した記録はありません",
    "emptyHint": "ライブ記録を完了すると、ここでその主要な概要が表示されます。",
    "duration": "期間",
    "expGained": "経験値を獲得しました",
    "expPerHour": "経験値 / 時間",
    "mesosDelta": "純増メル",
    "pageLabel": "履歴のページネーション",
    "loadFailed": "履歴を読み込めませんでした。もう一度やり直してください。",
    "expandJourney": "相効率を拡大",
    "collapseJourney": "コラプスフェーズの効率",
    "journeyLoading": "フェーズ効率データの読み込み",
    "journeyLoadFailed": "相効率データをロードできませんでした",
    "journeyRetry": "もう一度ロードしてみてください",
    "delete": "削除",
    "deleteRecord": "この記録を削除",
    "deleteTitle": "履歴記録を削除する",
    "deletePrompt": "{date} から記録を削除しますか?これを元に戻すことはできません。",
    "deleteDone": "履歴記録が削除されました",
    "deleteFailed": "記録を削除できませんでした。もう一度やり直してください。",
    "transferHint": "完了した履歴と区間効率データをブラウザ間で移動します。認識およびキャリブレーション設定は含まれません。",
    "export": "エクスポート記録",
    "import": "インポート記録",
    "exportDone": "エクスポートされた {count} 履歴記録",
    "exportFailed": "履歴をエクスポートできませんでした。もう一度やり直してください。",
    "importTitle": "履歴のインポートを確認する",
    "importConfirm": "マージインポート",
    "importConfirmIntro": "{count} 履歴記録をマージします。既存のローカル 記録は上書きされません。",
    "importExportedAt": "エクスポートされたファイル",
    "importDuplicates": "スキップする正確な重複",
    "importConflicts": "名前を変更するには ID が競合します",
    "importMergeHint": "インポートはアトミックに書き込まれます。いずれかの記録が無効な場合、データは書き込まれません。",
    "importDone": "{imported} を追加し、{skipped} の重複をスキップし、{remapped} 競合の名前を変更しました。",
    "importDisabledRecording": "履歴をインポートする前に現在の記録を終了してください",
    "importTooLarge": "ファイルが 64 MiB を超えているためインポートできません",
    "importInvalidJson": "ファイルは有効な JSON 履歴データではありません",
    "importInvalidFormat": "この履歴ファイル形式は認識されません",
    "importUnsupported": "この履歴ファイルのバージョンはサポートされていません",
    "importInvalidData": "履歴データが不完全か破損しています。何も輸入されませんでした。",
    "importLimitExceeded": "記録または区間効率の限界を超えました",
    "importWriteFailed": "歴史を書くことはできませんでした。何も輸入されませんでした。",
    "importFailed": "履歴をインポートできませんでした。ファイルを確認して、再試行してください。",
    "clear": "すべての記録をクリアする",
    "clearTitle": "履歴をクリアする",
    "clearPrompt": "これにより、このブラウザに保存されているすべての履歴が完全に削除されます。",
    "clearDone": "履歴がクリアされました",
    "clearFailed": "履歴を消去できませんでした。もう一度やり直してください。",
    "clearDisabledRecording": "履歴をクリアする前に現在の記録を終了してください"
  },
  "rank": {
    "title": "狩場効率ランキング",
    "subtitle": "信頼できるマップ 経験値 の効率をレベル、職業、データ ソースごとに比較する",
    "filters": "ランキングフィルター",
    "levelBucket": "レベル範囲",
    "levelRange": "Lv.{start}～{end}",
    "job": "職業",
    "allJobs": "すべての職業",
    "jobRecords": "{count} 記録",
    "source": "データソース",
    "sourceName": {
      "all": "すべてのソース",
      "mxdc": "小冊子",
      "fengji": "Maple Log"
    },
    "qualificationRule": "少なくとも {users} のプレーヤーと有効な記録時間が {duration} 必要です。各プレイヤーは有効時間を{perUser}記録した後にカウントします。",
    "tabs": "ランキングタイプ",
    "formal": "集計済み",
    "accumulating": "収集",
    "formalTitle": "集計済みランキング",
    "formalHint": "これらのマップは、比較対象となる対象ユーザーと信頼できる時間の両方のしきい値を満たしています。",
    "accumulatingTitle": "データの収集",
    "accumulatingHint": "より多くのプレーヤーまたは有効な記録時間が必要です。これらの 経験値 レートは参考値です。",
    "rank": "ランク",
    "map": "マップ",
    "typicalEfficiency": "標準的な効率",
    "commonRange": "一般的な効率範囲",
    "highReference": "高効率の参考値",
    "trustedSamples": "信頼できるサンプル",
    "currentReference": "現在の標準効率",
    "rateValue": "{value} 経験値 / 時間",
    "users": "{count}人",
    "hours": "{count} 時間",
    "sourceBreakdown": "Maple Log {fengji} · 小冊子 {mxdc}",
    "userProgress": "対象ユーザー {current}/{target}",
    "durationProgress": "信頼できる時間 {current}/{target}",
    "userThreshold": "公式ランキングに必要なプレイヤー数",
    "durationThreshold": "公式ランキングの有効所要時間",
    "resultCount": "{count}マップ",
    "updatedAt": "データ更新 {time}",
    "rowUpdatedAt": "{time}を更新しました",
    "refresh": "ランキングを更新する",
    "retry": "もう一度試してください",
    "loading": "ランキングを読み込んでいます",
    "refreshing": "更新中",
    "pagination": "ランキングのページネーション",
    "statisticsHelp": "標準効率は中間の結果を表します。共通範囲はユーザーサンプルの中央半分をカバーします。より高い効率のリファレンスは、速度制限ではなく、より強力な結果を反映します。",
    "metadataWarning": "フィルターのメタデータは使用できません。デフォルトの範囲としきい値が使用されています。",
    "metadataStaleWarning": "フィルターのメタデータを更新できませんでした。既存の値は引き続き使用されます。",
    "emptyTitle": "一致するマップはまだありません",
    "emptyFormalHint": "別のレベル範囲、職業、またはソースを試すか、後でもう一度確認してください。",
    "emptyAccumulatingHint": "現在、これらのフィルターのデータを収集しているマップはありません。",
    "error": {
      "network": "ランキングサービスに到達できませんでした。接続を確認して、もう一度試してください。",
      "response": "ランキングサービスは一時的にご利用いただけません。後でもう一度試してください。",
      "invalid-data": "ランキング サービスは、Maple Log が読み取れないデータを返しました。後でもう一度試してください。"
    }
  },
  "changelog": {
    "title": "更新履歴",
    "subtitle": "Maple Log の新機能、改善、修正。",
    "timelineLabel": "Maple Log リリース",
    "latest": "現在",
    "directory": "このページでは",
    "changeCount": "{count} の変更",
    "categories": {
      "added": "新機能",
      "improved": "改善点",
      "fixed": "修正"
    },
    "announcement": {
      "title": "新機能",
      "history": "更新履歴を表示する",
      "dismiss": "わかりました",
      "close": "アップデートのお知らせを閉じる"
    },
    "releases": {
      "update20261031": {
        "items": {
          "gcwPercentageExp": { "title": "GCWの経験値％表示", "description": "経験値が％のみ表示される場合も、獲得量と効率を推定できます。" },
          "historyRecovery": { "title": "履歴データの救出", "description": "利用可能な記録をエクスポートし、問題のある元データを別途保存できます。" },
          "widgetSkins": { "title": "ウィジェットスキン", "description": "12種類のテーマを刷新し、さまざまなウィンドウサイズでの表示を改善しました。" },
          "precisionCalibration": { "title": "認識範囲の調整", "description": "拡大表示、1ピクセル単位の微調整、ゲーム種類の直接切り替えに対応しました。" },
          "personalMapReference": { "title": "自分の狩場データ", "description": "効率範囲の計算を改善し、普段の狩りの成果をより反映するようにしました。" },
          "experienceRecognition": { "title": "経験値とステータス", "description": "経験値・HP／MPの認識と更新の遅延を改善し、一部のレベルアップ時の集計誤差を修正しました。" },
          "buffReminders": { "title": "BUFF通知", "description": "アイコン認識を改善し、複数通知の同時発生時の音声漏れと、期限切れ通知の遅延再生を修正しました。" },
          "captureRecovery": { "title": "画面共有の復旧", "description": "キャプチャ停止の誤判定を修正し、ページに戻った際や再共有後の復旧を改善しました。" }
        }
      },
      "update20261027": {
        "items": {
          "personalMapReference": { "title": "自分のマップ記録を参考に", "description": "ランキングに記録済みのマップを表示し、このブラウザーに保存された過去の効率範囲を確認できます。" },
          "rankEntry": { "title": "マップランキング", "description": "マップランキングを開くと、現在のレベルと職業に合った結果を自動表示します。" },
          "liveDashboard": { "title": "ダッシュボード", "description": "経験値・メル・グラフの配置を調整し、状態表示と狭い画面での表示を改善しました。" },
          "buffAlerts": { "title": "BUFF通知", "description": "終了間近の表示を強調し、ウィジェットのアイコンを大きくしました。" },
          "expPreview": { "title": "経験値プレビュー", "description": "プレビューと確定済みの読み取り値が一致しない問題を修正しました。" },
          "mesosRecognition": { "title": "メルの認識", "description": "一部の状況でメルを正しく認識できない問題を修正しました。" },
          "resourceLoading": { "title": "音声とリソース", "description": "再読み込み時、低速回線、リクエスト制限時の読み込みを改善しました。" }
        }
      },
      "update20261025": {
        "items": {
          "customBuffAudio": { "title": "BUFFのカスタム音声", "description": "通知音の追加・試聴・管理に対応しました。音声はこのブラウザー内だけに保存されます。" },
          "mapEfficiency": { "title": "マップの参考効率", "description": "職業の照合と表示を改善しました。" },
          "rankFilters": { "title": "ランキングの絞り込み", "description": "職業アイコン、表示間隔、展開アニメーションを改善しました。" },
          "buffSearch": { "title": "BUFFの検索", "description": "GCWで複数のBUFFを検索・再検出する処理を改善しました。" },
          "buffCountdown": { "title": "BUFFカウントダウン", "description": "通常モードでは数字が消えると、古いカウントダウンと未再生の通知を一時停止します。" },
          "buffIcons": { "title": "アイコン認識", "description": "GCWで小さく表示されたヘイストの認識漏れを改善しました。" }
        }
      },
      "update20261023": {
        "items": {
          "multiJobFilter": { "title": "複数職業で絞り込み", "description": "ランキングで複数の職業を同時に選択できるようになりました。職業カテゴリ、系統、個別の転職を組み合わせて絞り込めます。" },
          "buffManagement": { "title": "設定からBUFFを管理", "description": "設定ページからBUFFの追加・管理ができます。ゲームに接続する前でも通知を設定できます。" },
          "sessionStart": { "title": "記録開始をスムーズに", "description": "経験値を確認できた時点で計測を開始し、レベルやマップなどの情報は後から補います。" },
          "gameRecognition": { "title": "ゲーム画面の認識", "description": "クラシック画面での経験値の誤読や読み取りの中断、およびGCWのレベル・マップ認識を改善しました。" },
          "expAccounting": { "title": "経験値の集計", "description": "レベルアップ、死亡、再接続後の一部の状況で経験値の集計に誤差が生じる問題を修正しました。" },
          "buffRecognition": { "title": "BUFFの認識", "description": "似たアイコンの誤認識や残り時間の誤ったリセットを減らし、BUFF追加時の入力チェックと初期設定を修正しました。" }
        }
      },
      "update20261020": {
        "items": {
          "manboVoice": { "title": "Manboの音声通知", "description": "中国語の通知はデフォルトでManboの声を使用します。システムが提供する広東語や台湾華語などの声も選択できます。" },
          "manualBuffTimer": { "title": "BUFFの手動タイマー", "description": "有効なカウントダウンを初めて認識すると独立して計時し、終了後は設定した間隔で繰り返します。その後に画面が隠れても影響を受けません。手動モードはゲーム内のBUFF更新に同期せず、接続を切ると停止します。" },
          "dropSellPrice": { "title": "ドロップ品の売却価格", "description": "ドロップ品の詳細に売却価格を追加し、アイテムの価値を確認できるようにしました。" },
          "sessionAutosave": { "title": "記録の自動保存", "description": "記録中は60秒ごとに進行状況を保存し、ページが予期せず閉じた際のデータ損失を減らします。" },
          "runtimePerformance": { "title": "動作負荷を軽減", "description": "低負荷モードの認識スケジュールを改善し、ウィジェット、デイリーパネル、経験値グラフでの重複計算を減らしました。" },
          "dashboardCards": { "title": "柔軟なダッシュボード表示", "description": "認識を無効にするとメルやHP／MPの領域を非表示にでき、BUFFは引き続き表示できます。" },
          "buffCountdown": { "title": "BUFFカウントダウンの安定性を改善", "description": "複雑な背景や小さな数字の認識を改善し、カウントダウンの中断、誤読、通知漏れを減らしました。" },
          "recognitionAccuracy": { "title": "経験値・メル・ステータスの認識", "description": "経験値、メル、HP／MPの読み取りを改善し、高解像度画面での認識を安定させました。" }
        }
      },
      "update20261014": {
        "items": {
          "experienceSettings": { "title": "経験値の設定", "description": "レベルアップ予測はデフォルトでリアルタイムの効率を使用します。平均効率への切り替えと、時間／分単位の表示に対応しました。" },
          "attributeRecognition": { "title": "ステータス画面の認識", "description": "中国クラシックサーバーでは、ステータス画面からレベル・職業・経験値・HP・MPを読み取り、利用できない場合は画面下部の表示に切り替えます。" },
          "recognitionPerformance": { "title": "認識パフォーマンス", "description": "画面キャプチャを最適化し、重複した計算と画像の読み取りを削減しました。4Kのテスト条件では、BUFFの1フレームあたりの画像読み取り量が約23%減少しました。" },
          "journeyChart": { "title": "レベリンググラフ", "description": "表示期間の切り替え、平均線、ピーク、マップと中断区間の表示を追加しました。クリックで測定値を固定できます。" },
          "gcwRecognition": { "title": "GCWの認識", "description": "ウルトラワイド画面でのステータスバー、マップ、メルの位置検出を改善しました。" },
          "buffCountdown": { "title": "BUFFの残り時間", "description": "色付きや小さな文字で表示される一部のBUFF残り時間の誤読を修正しました。" },
          "widgetDisplay": { "title": "ウィジェット表示", "description": "文字のはみ出し、レイアウトの復元、レベルアップ予測の表示に関する問題を修正しました。" },
          "expChartContinuity": { "title": "経験値グラフの中断", "description": "経験値の確認中に正常なグラフが不要に途切れる問題を修正しました。" },
          "captureFrameRate": { "title": "キャプチャのフレームレート制限", "description": "一部の状況でキャプチャのフレームレート制限が正しく適用されない問題を修正しました。" }
        }
      },
      "update20261010": {
        "items": {
          "historyTools": { "title": "履歴の使いやすさを改善", "description": "マップ別統計、記録検索、2件の記録比較、一括削除を追加し、分割表示で詳細を確認できるようにしました。" },
          "widgetWindowModes": { "title": "ウィジェットの開き方を追加", "description": "最前面のピクチャーインピクチャーか独立ウィンドウを選べます。前回の選択も保存します。" },
          "gcwRecognition": { "title": "GCW（国際クラシックサーバー）の認識を改善", "description": "小さな画面、経験値、メルの読み取りと、インベントリ移動や手動での範囲指定後の認識復旧を改善しました。" },
          "buffDetection": { "title": "BUFFの認識漏れを修正", "description": "経験値増加などのBUFFアイコンが移動した後に認識できなくなる問題を減らしました。" }
        }
      },
      "update20261008": {
        "items": {
          "gcwSupport": { "title": "GCW（国際クラシックサーバー）対応を追加", "description": "英語のゲーム画面に自動対応し、レベル、経験値、HP、MP、メル、マップ、職業を読み取ります。" },
          "defaultWidget": { "title": "デフォルトウィジェットを刷新", "description": "経験値効率、リアルタイム速度、レベル進捗、BUFFの配置を見直しました。従来のデフォルトは「クラシック」として引き続き利用できます。" },
          "compactWidget": { "title": "小さなウィンドウの表示を改善", "description": "狭いウィンドウでの数値、ボタン、記録時間の配置を改善し、見切れや重なりを減らしました。" }
        }
      },
      "update20261005": {
        "items": {
          "historyStatistics": { "title": "履歴ページを刷新", "description": "日・週・月ごとに獲得量と効率を確認できます。推移グラフ、記録カレンダー、前の期間との比較にも対応しました。" },
          "expRecognition": { "title": "経験値の異常を修正", "description": "経験値の誤読や異常な速度を減らし、読み取りの復旧とメイン画面・ウィジェットの表示の統一を改善しました。" },
          "expRateExplanation": { "title": "効率の説明を改善", "description": "記録全体の平均と直近60秒の効率を区別し、グラフ用データの収集状況を表示します。" },
          "buffRecognition": { "title": "BUFF認識を改善", "description": "解像度に応じたアイコンと残り時間の認識を改善し、似たアイコンの取り違えを減らしました。" },
          "widgetExperience": { "title": "ウィジェットを改善", "description": "初回のサイズ変更ガイドと職業情報を追加し、ボタンと経験値グラフの配置を調整しました。" }
        }
      },
      "update20260930": {
        "items": {
          "currentMap": { "title": "現在のマップ", "description": "記録中に認識したマップ、モンスター、ドロップ品を確認でき、近いレベル帯と職業のレベル上げ効率も参考にできます。" },
          "dropDetails": { "title": "ドロップ情報", "description": "マップ詳細にドロップ率とドロップ元のモンスターを追加し、モンスター別にドロップ品を絞り込めるようにしました。" },
          "liveLayout": { "title": "ダッシュボードのレイアウト改善", "description": "レベル上げのグラフと現在のマップ情報を見やすいよう、ダッシュボードの配置を調整しました。" },
          "skinPreview": { "title": "ウィジェットスキンのプレビュー改善", "description": "スキンを選択・確認するときに異なるウィンドウサイズを表示し、テディのアニメーションと画像も更新しました。" },
          "widgetRecovery": { "title": "ウィジェット表示エラーの修正", "description": "表示エラーから復旧しやすくし、内容のエラーが記録の開始・一時停止・終了に影響しにくくしました。" },
          "shortSessions": { "title": "短すぎる記録を除外", "description": "終了後、5秒未満の記録は履歴に残らなくなりました。" }
        }
      },
      "update20260928": {
        "items": {
          "realtimeRateChart": { "title": "リアルタイム速度の推移グラフ", "description": "ライブ画面とウィジェットに直近5分のEXP速度グラフを追加しました。レベル上げのペースを把握しやすくなります。" },
          "widgetLayout": { "title": "ウィジェットのレイアウト改善", "description": "ウィジェット内の情報配置と余白を調整し、主要指標と速度グラフがスキンやウィンドウサイズを問わず見やすくなりました。" }
        }
      },
      "update20260924": {
        "items": {
          "buffAlerts": { "title": "BUFF 通知", "description": "監視したい BUFF を追加すると、ゲーム画面への接続後に自動で確認できます。終了間際や消失時には音声通知とアイコンの点滅でお知らせします。" },
          "rateUnits": { "title": "時間・分単位の切り替え", "description": "経験値とメルの獲得速度を時間単位または分単位で表示できます。設定で切り替えても集計結果は変わりません。" },
          "lightweightOcr": { "title": "軽量文字認識モデル", "description": "端末の負荷を抑える軽量モデルと、認識精度の高い標準モデルを選べます。" },
          "artaleSupport": { "title": "Artale に対応", "description": "Artale のゲーム画面に対応し、そのレイアウトからキャラクター情報とレベル上げのデータを読み取れます。" },
          "newLanguages": { "title": "表示言語を 3 つ追加", "description": "繁体字中国語、日本語、韓国語に対応しました。設定から切り替えられます。" },
          "userExperience": { "title": "操作性を改善", "description": "設定、認識、データ表示の操作や見せ方を見直し、よく使う機能を使いやすくしました。" },
          "recognitionAccuracy": { "title": "認識精度を改善", "description": "画面上の位置特定と文字の読み取りを改善し、一部の場面での誤読や読み落としを減らしました。" },
          "widgetDisplay": { "title": "ウィジェットの表示不具合を修正", "description": "一部のサイズや状態でウィジェットの内容が正しく表示されない問題を修正しました。" },
          "styleIssues": { "title": "画面表示の問題を修正", "description": "一部のページと操作部品の表示を調整しました。" }
        }
      },
      "update20260918": {
        "items": {
          "rankPageRebuild": {
            "title": "ランキングページをリニューアルしました",
            "description": "マップドロップとマップ検索が追加され、レイアウトがより明確になり、詳細がより豊富になりました。"
          },
          "browserCompatibility": {
            "title": "より多くのブラウザで動作します",
            "description": "公式の Edge または Chrome ではないブラウザでも、可能であればウィンドウを選択してウィジェットを開くことができます。常時表示または認識が利用できない場合は、Maple Log でその理由が説明されます。最新のEdgeとChromeは変更ありません。"
          },
          "captureTimeout": {
            "title": "より信頼性の高い接続",
            "description": "初めてウィンドウを選択するとき、またはサイトを再度開いた後に失速したりスピンしたりする可能性が低くなります。"
          }
        }
      },
      "update20260914": {
        "items": {
          "realtimeExpRate": {
            "title": "リアルタイム 経験値 レート",
            "description": "経験値/時間は、最後の 1 分がセッション平均より速いか遅いかを示します。分岐すると矢印が表示されます。カーソルを合わせると詳細が表示されます。"
          },
          "firstUseAutoLocate": {
            "title": "最初の接続時に自動認識",
            "description": "初めてゲーム ウィンドウに接続すると、自動認識が開きます。ステータスバーを表示したままにしてください。インベントリを開いて、メル も見つけます。スキップしても構いません。"
          },
          "clearerMetrics": {
            "title": "より明確なライブ指標",
            "description": "セカンダリ フィールドは隠れているため、経験値 や メル レートなどのコア値が目立ちます。"
          }
        }
      },
      "update20260913": {
        "items": {
          "autoLocateMesos": {
            "title": "メル の自動位置特定",
            "description": "インベントリを開き、メル を表示したままにして、自動認識で見つけます。 メル が見つからない場合は、単独で再試行してください。"
          },
          "factoryReset": {
            "title": "工場出荷時設定にリセット",
            "description": "設定により、記録と設定、および認識リソースをクリアできます。起動とキャプチャの失敗もここを指します。"
          },
          "pipWindowSize": {
            "title": "PiP はそのサイズを記憶します",
            "description": "ウィジェットは最後に使用したサイズで再び開きます。"
          },
          "calibrationPreview": {
            "title": "より簡単なキャリブレーションフレームワーク",
            "description": "プレビューではキャプチャのアスペクト比が維持され、小さなボックスであっても掴みやすくなります。"
          },
          "recoveryPaths": {
            "title": "回復するためのその他の方法",
            "description": "セットアップまたはキャプチャが失敗した場合は、工場出荷時の設定を復元するか、ブラウザを更新してください。自動認識タイムアウトも表示されます。"
          },
          "highDpiRecognition": {
            "title": "高解像度の認識エラー",
            "description": "領域はキャプチャされたピクセル上に配置されるため、ゲーム内の解像度がキャプチャ サイズと一致する必要はありません。 HUD 検索は約 0.5 ～ 4 倍の UI スケールをカバーします。"
          },
          "upgradeExpAccounting": {
            "title": "レベルアップは経験値の損失としてカウントされなくなりました",
            "description": "突然の経験値の低下はレベルチェックを待ちます。確認されたレベルアップはクレジットされます。未確認の実行はネガティブになるのではなく、不完全としてマークされます。"
          }
        }
      },
      "update20260910": {
        "items": {
          "newLayoutAutoLocate": {
            "title": "新しいゲーム UI と自動認識",
            "description": "レベル、職業、HP、MP、経験値、マップ名をワンステップで検索します。 メル は、インベントリを開いた状態で手動でフレーム化する必要があります。複数のサイズと UI スケールをサポートし、進行状況と診断をエクスポートします。見つからないものは再試行してください。"
          },
          "rankMapTip": {
            "title": "ランキングのマップ情報",
            "description": "マップ名にカーソルを合わせるか、「詳細」をタップすると、ミニマップ、地域、モンスター、NPC、および関連メモが表示されます。"
          },
          "calibrationSimpler": {
            "title": "より簡単な校正",
            "description": "HP、MP、および 経験値 テキスト行のみをフレーム化します。バーは自動的にチェックされます。ポジションはキャプチャ サイズごとに保存され、ワンステップでデフォルトに復元でき、より明確な結果と拒否理由が得られます。"
          },
          "jobLineRecognition": {
            "title": "より正確な職業認識",
            "description": "OCRの前に職業名の行を検索し、職業としての誤読レベルやキャラクター名の読み間違いを減らします。"
          }
        }
      },
      "update20260909": {
        "items": {
          "recognitionPerformance": {
            "title": "認識パフォーマンスの大幅な向上と設定の再設計",
            "description": "5 つのプリセット (低、中、デフォルト、高、超) は、キャプチャと認識のレートを一緒に制御します。新しいユーザーと移行された設定はデフォルトを使用します。 「低」と「中」では負荷が軽減され、更新が遅くなります。また、タスクバーのフリーズと応答不能も修正されました。"
          },
          "hpMpRates": {
            "title": "HP/MP消費率を削除",
            "description": "ライブページとウィジェットには、現在のHP/MP、最大値、ステータスバーのみが表示されるようになりました。消費料金、回復料金、時間料金は削除されます。歴史カードは、マップ、キャラクター、経験値、および メル を強調します。"
          },
          "lowFrequencyMesos": {
            "title": "低い読み取り周波数でのより信頼性の高い メル トラッキング",
            "description": "読み込みが遅いため、インベントリが開いたままになっている間、純利益の追跡が維持されるようになりました。共有ソースを閉じたり、不確実なフレーム、一時停止、または切り替えを行うと、依然として継続性が損なわれます。"
          },
          "mapRomanSuffix": {
            "title": "マップ名の接尾語におけるローマ数字の認識を修正しました。",
            "description": "認識では、III などの誤って読み取られたローマ数字の接尾辞を復元し、切り捨てられたり分割されたマップ名を減らしたりしようとします。"
          }
        }
      },
      "update20260908": {
        "items": {
          "streamSkins": {
            "title": "ウィジェットスキン",
            "description": "Adventure HUD、Minimal Report、Mushroom Companion、Snowfield Expedition、ルディブリアム Block Station、ピンクビーン Radio、Kerning Graffiti、Aqua Voyage が追加され、穏やかなアイドルアニメーションとレベルアップアニメーションが追加されました。これらは Orbis、Sakura Garden、Arcane Starlight に代わるものです。"
          },
          "streamConnect": {
            "title": "ストリーミング設定ガイド",
            "description": "設定の新しいガイドでは、ウィジェットを開いてキーカラーを選択し、OBS または同様のツールでウィンドウ キャプチャとクロマ キー フィルターを追加する手順が説明されています。"
          },
          "allLevelRankings": {
            "title": "すべてのレベルのランキングを表示",
            "description": "マップランキングはすべてのレベルをサポートするようになり、公平な効率比較のために各レベル範囲が個別に計算および表示されます。"
          },
          "localDiagnostics": {
            "title": "パフォーマンスとローカル診断",
            "description": "負荷を軽減するために、設定ではキャプチャとフレーム検査のレート制限を個別に提供できるようになりました。自動アップロード、スクリーンショット、OCR テキスト、またはウィンドウ タイトルを使用せずに、ローカル診断を表示、コピー、またはダウンロードします。"
          },
          "screenCaptureFallback": {
            "title": "ウィンドウキャプチャが失敗した場合に画面キャプチャに切り替える",
            "description": "ウィンドウのキャプチャが失敗した場合は、画面全体をキャプチャしてみてください。トラブルシューティングではウィンドウ モード、ブラウザ、グラフィック ドライバーがカバーされており、フィードバック用にコピーできる診断も含まれています。"
          },
          "recognitionRecovery": {
            "title": "より安定した認識とスムーズな復帰",
            "description": "変更されていないフレームでは、強調を繰り返す必要が少なくなります。 OCR の再試行は、連続して失敗すると速度が低下し、成功すると通常に戻るため、ストールやリセットの繰り返しが減少します。"
          },
          "captureFailureGuidance": {
            "title": "より明確なキャプチャ失敗メッセージ",
            "description": "キャプチャの失敗、タイムアウト、および一時的な利用不可について、画面キャプチャ、ウィンドウの再選択、およびさらなるトラブルシューティングのオプションを備えた、より明確な説明が追加されました。"
          },
          "jobRecognition": {
            "title": "職業領域のレベルまたはキャラクター名の読み間違い",
            "description": "職業認識領域を強化し、近くのレベルやキャラクター名を職業として誤読することを減らしました。"
          }
        }
      },
      "update20260907": {
        "items": {
          "mapRanking": {
            "title": "レベリングマップランキング（ベータ版）",
            "description": "レベル範囲、職業、データ ソースごとにマップ 経験値 の効率を比較して、トレーニング先の選択に役立てます。"
          },
          "widgetSkins": {
            "title": "ウィジェットスキン",
            "description": "[設定] で新しいウィジェット スキンから選択して、レベリング表示をカスタマイズします。"
          },
          "efficiencyChart": {
            "title": "再設計された効率トレンド",
            "description": "レベリングの進行状況をより明確に確認できます。ダッシュボードのステージ効率チャートと履歴は、ドラッグしてズームしたり、時間内でパンしたり、ダブルクリックして全体ビューを復元したりすることをサポートしています。"
          },
          "calibrationExamples": {
            "title": "校正の選択例",
            "description": "新しい領域選択の例は、ゲーム画面に対して認識領域を調整するのに役立ちます。"
          },
          "autoRegion": {
            "title": "自動領域検出",
            "description": "認識領域は自動的に配置されるため、手動による選択とキャリブレーションが削減されます。"
          },
          "recognitionPerformance": {
            "title": "認識パフォーマンスの大幅な改善",
            "description": "認識オーバーヘッドを大幅に削減し、ゲームのフレームレートへの影響を最小限に抑え、スムーズな録画を維持します。"
          },
          "startFeedback": {
            "title": "記録を開始できない場合の明確な理由",
            "description": "レベルまたは完全な 経験値 読み取り値が未確認である場合、認識が遅い場合、または画面共有が中断された場合、ダイアログに原因が説明され、調整オプションが表示されます。"
          },
          "responsiveWidget": {
            "title": "より柔軟なウィジェットのレイアウト",
            "description": "改良されたレスポンシブ レイアウトにより、ウィジェットのサイズをコンパクトからワイドまで自由に変更できるため、データを読みやすく保つことができます。"
          },
          "firefoxCompatibility": {
            "title": "Firefox の互換性修正",
            "description": "Firefox でアプリが正しく動作しない問題を修正しました。"
          },
          "recordingStart": {
            "title": "録画起動の修正",
            "description": "一部のプレーヤーが記録を開始できない問題を修正し、起動の信頼性を向上させました。"
          }
        }
      },
      "update20260904": {
        "items": {
          "expRate": {
            "title": "経験値レート",
            "description": "1 時間あたりの 経験値 は、獲獲得 経験値 を記録期間で割ったものを使用し、レベルアップ全体で獲得を引き継ぎます。"
          },
          "mesosAccuracy": {
            "title": "メル 認識",
            "description": "インベントリの可視性を確認し、測定値間の変更のバランスをとって、不正確な時間料金を削減します。"
          },
          "startupSpeed": {
            "title": "起動時の読み込み",
            "description": "ウィンドウの選択後に認識リソースを準備して、最初の待ち時間とリソースの使用を削減します。"
          },
          "windowSelection": {
            "title": "ウィンドウの選択",
            "description": "ブラウザーのウィンドウ ピッカーを開く前のバックグラウンド作業を減らし、応答性を向上させます。"
          },
          "efficiencyTrend": {
            "title": "効率の傾向をレベリングする",
            "description": "ダッシュボードで効率の変化を確認します。新しい記録の傾向もローカル履歴に保存されます。"
          }
        }
      },
      "launch20260902": {
        "summary": "最初に使用可能なリリースでは、ローカル ゲーム画面の認識と、経験値、メル、およびその他のレベリング データの追跡がブラウザーに提供されました。"
      }
    }
  },
  "settings": {
    "title": "設定",
    "subtitle": "外観、認識、ローカルリセットを管理する",
    "language": "表示言語",
    "languageHint": "即座に適用され、このブラウザに保存されます",
    "theme": "外観",
    "appearanceHint": "表示言語、ライト・ダークモード、速度の単位を設定します",
    "themeMode": "ライト・ダークモード",
    "themeHint": "環境に合った表示モードを選択してください",
    "light": "ライトモード",
    "dark": "ダークモード",
    "pipSkin": "ウィジェットの設定",
    "pipSkinDefault": "デフォルト",
    "pipSkinClassic": "クラシック",
    "recognition": "読み取りと認識",
    "recognitionHint": "各データ ソースの読み取り速度と認識動作を調整します。",
    "captureRateUnit": "{count}/秒",
    "frequencyDetails": "データによる読み取り頻度",
    "recognitionIntervalSeconds": "{count}秒ごとに1回",
    "recognitionIntervalPerSecond": "{count} 回/秒",
    "recognitionDisabled": "認識しない",
    "recognitionRequired": "必須",
    "recognitionAutomatic": "自動",
    "recognitionDisabledState": "認識オフ",
    "metricFrequencyHint": "経験値、メル、および HP/MP のデフォルトは 1 秒に 1 回です。レベルとマップは 4 秒ごとに、職業は 30 秒ごとに実行されます。読み取りは低速なデバイスでキューに入れられる場合があります。",
    "metricFrequencyAria": "{metric} 読み取り周波数",
    "metricFrequency": {
      "exp": {
        "label": "経験値",
        "hint": "経験値 の獲得とレベルアップ"
      },
      "mesos": {
        "label": "メル",
        "hint": "インベントリは開いている必要があります"
      },
      "hpMp": {
        "label": "HP/MP",
        "hint": "数値・消費・回復"
      },
      "hp": {
        "label": "HP",
        "hint": "数値・消費・回復"
      },
      "mp": {
        "label": "MP",
        "hint": "数値・消費・回復"
      },
      "level": {
        "label": "レベル",
        "hint": "レベルアップと補正"
      },
      "mapName": {
        "label": "マップ",
        "hint": "現在のマップ名"
      },
      "jobName": {
        "label": "職業",
        "hint": "ゲーム内職業"
      }
    },
    "minConfidence": "読み取りの厳密さ",
    "minConfidenceHint": "値が大きいほど選択性が高く、より多くの低品質の結果が拒否されます。",
    "changeThreshold": "画面切り替え感度",
    "changeThresholdHint": "値が低いほど小さな変化が検出され、別の読み取りがより早くトリガーされます。",
    "restoreRecommendedRecognition": "デフォルトに戻す",
    "recognitionRestored": "デフォルトの認識設定が復元されました",
    "backgroundRecording": "バックグラウンドでの停止を防ぐ",
    "backgroundHint": "Chrome と Edge はメモリを節約するためにバックグラウンドに残っているタブを一時停止し、認識と記録を一時的に停止することがあります。このような中断を減らすために、ブラウザの常時アクティブ リストに Maple Log を追加します。",
    "setupPath": "設定パス",
    "chromePath": "設定→パフォーマンス→メモリセーバー→これらのサイトを常にアクティブにしておく",
    "edgePath": "設定→システムとパフォーマンス→パフォーマンス→これらのサイトをスリープ状態にしないでください",
    "currentDomain": "現在のサイトのドメイン",
    "addDomainHint": "最終設定を開いて、このドメインを追加します。",
    "copyDomain": "ドメインをコピーする",
    "domainCopied": "コピーされました",
    "domainCopyDone": "現在のドメインがコピーされました",
    "domainCopyFailed": "コピーに失敗しました。現在のドメインを手動で追加してください。",
    "reset": "リセットと復元",
    "resetBody": "環境設定、調整、履歴を最初に使用した状態に復元します。",
    "factoryReset": "初期状態に戻す",
    "factoryResetTitle": "初期状態に戻す",
    "factoryResetIntro": "これにより、このブラウザーで選択した Maple Log データが削除され、アプリがリロードされます。",
    "factoryResetItems": {
      "data": "記録と設定",
      "resources": "認識リソース"
    },
    "factoryResetItemHints": {
      "data": "履歴、調整、および設定",
      "resources": "次回からは再度ダウンロードする必要があります"
    },
    "factoryResetConfirm": "初期状態に戻す",
    "factoryResetDisabledRecording": "工場出荷時の設定を復元する前に現在の記録を終了してください",
    "factoryResetFailed": "工場出荷時の設定を復元できませんでした。もう一度やり直してください。",
    "ocrChecking": "設定を確認しています",
    "ocrDownloading": "画面認識の準備中",
    "ocrPrepared": "認識リソースの準備完了",
    "ocrInitializing": "認識エンジンを起動中",
    "ocrReady": "画面認識の準備完了",
    "ocrError": "セットアップに失敗しました"
  },
  "about": {
    "updates": "アップデート",
    "disclaimer": {
      "title": "免責事項",
      "intro": "使用する前にツールの制限と責任を理解してください。",
      "accuracyTitle": "統計は参考用です",
      "accuracyBody": "画面認識は、解像度、障害物、ゲームのアップデートによって影響を受ける可能性があります。 経験値、収益、効率の数値は不正確である可能性があります。常に実際のゲーム内データを参照してください。",
      "usageTitle": "アカウントの責任",
      "usageBody": "ゲームとサーバーの規約に従ってください。このツールはアカウントの安全性を保証するものではありません。ゲーム運営者の公開されたルールと決定が適用されます。",
      "accountNote": "ゲームルールの違反、他のサードパーティソフトウェアの使用、またはこのツールに関係のないその他の原因によって引き起こされるアカウントの問題、ログイン制限、または禁止は、プレイヤーの責任であり、このツールに起因するものではありません。",
      "rightsTitle": "知的財産の尊重",
      "rightsBody": "ゲームの名前、商標、資産はそれぞれの権利所有者に帰属します。著作権またはその他の権利に関する懸念がある場合は、上記のフィードバック チャネルを通じて作者にお問い合わせください。",
      "note": "適用される法律で認められる範囲で、作成者は、このツールの使用から生じる不正確な統計、データ損失、またはその他の損失に対して責任を負いません。この免責事項は、法的に除外できない責任を除外または制限するものではありません。"
    },
    "title": "Maple Log について",
    "subtitle": "Maple Log とその作成者について学ぶ",
    "projectDescription": "Maple Log はブラウザ内でゲーム画面をローカルに認識し、トレーニング アクティビティを有用な記録に変換します。",
    "authorLabel": "クリエイター",
    "authorName": "小淳",
    "openAuthorBilibili": "Bilibili で {name} を開く",
    "contactLabel": "クリエイターを探す",
    "contactHint": "その他のプロジェクトや最新情報については、これらのプロフィールにアクセスしてください。",
    "github": "GitHub",
    "bilibili": "ビリビリ",
    "openExternal": "外部ウェブサイトを開く",
    "feedbackTitle": "フィードバック",
    "feedbackHint": "QQ グループに参加するか、電子メールを送信して問題を報告し、経験を共有してください。",
    "qqGroup": "QQグループ",
    "copyGroup": "コピーグループ番号",
    "copyFeedbackGroup": "QQ グループ番号 {number} をコピーします",
    "feedbackCopied": "QQグループ番号をコピーしました",
    "feedbackCopyFailed": "コピーに失敗しました。グループ番号を手動でコピーしてください。",
    "email": "電子メール",
    "copyEmail": "メールをコピーする",
    "copyFeedbackEmail": "メールアドレスをコピー {email}",
    "emailCopied": "メールがコピーされました",
    "emailCopyFailed": "コピーに失敗しました。メールを手動でコピーしてください。",
    "safetyTitle": "ゲームにとって安全ですか?",
    "safetyIntro": "Maple Log はブラウザ専用のツールです。クライアントやプラグインをインストールせず、ゲーム ファイルを変更せず、ブラウザ内で認識を完全に実行します。",
    "safetyReport": "安全性レポートを読む",
    "safetyFairLabel": "ゲームには触れない",
    "safetyLocalLabel": "このコンピュータ上に残ります",
    "safetyFrame": "共有フレームのみ",
    "safetyFrameHint": "選択したウィンドウまたは画面を受け取りますが、ゲームプレイ ビデオは保存されません。",
    "safetyProcess": "ゲームプロセスへのアクセスはありません",
    "safetyProcessHint": "ゲーム メモリを読み取ったり、ゲーム コードを挿入またはフックしたりすることはありません。",
    "safetyInput": "自動入力なし",
    "safetyInputHint": "キーボードやマウスの入力をシミュレートしたり、ゲームにコマンドを送信したりすることはありません。",
    "safetyPromise": "ゲーム画面はこのコンピュータで処理され、アップロードされません。",
    "safetyReassure": "ゲームの資格情報は要求されず、ゲームの変更や自動プレイも必要ありません。",
    "safetyHow": "ブラウザーのキャプチャを承認し、ウィンドウまたは画面を選択します。この権限は、ゲーム メモリやログイン資格情報へのアクセスを許可するものではありません。共有画面全体には、目に見える機密コンテンツが含まれます。",
    "safetyStepSandbox": "ブラウザの権限内で動作",
    "safetyStepSandboxHint": "ディスプレイ キャプチャでは、ゲーム メモリやログイン資格情報へのアクセスは許可されません。",
    "safetyStepChoose": "共有するウィンドウを自分で選択",
    "safetyStepChooseHint": "表面を選ぶのはあなたです。共有画面全体には、その上に表示されるウィンドウが含まれます。",
    "safetyStepLocal": "このコンピュータで読む",
    "safetyStepLocalHint": "そのウィンドウを画像として扱い、ここで数値を読み取ります。写真はオンラインでは送信されません。",
    "privacyTitle": "プライバシー保護",
    "privacyPromise": "プレイヤー情報は一切収集せず、データは処理の全過程で匿名です。",
    "privacyIdentity": "個人情報は収集しません",
    "privacyIdentityHint": "ゲームのアカウント、パスワード、キャラクター名を求めず、プレイヤーを特定できる情報は収集・送信しません。",
    "privacyLocal": "元の画面は端末内で処理",
    "privacyLocalHint": "画面・スクリーンショット・OCR 原文はブラウザ内で処理し、認識領域や調整設定も端末内に保存します。",
    "privacyRank": "ランキングは匿名の統計",
    "privacyRankHint": "条件を満たす匿名の統計概要だけを自動送信します。ランダムな識別子は重複排除用で、ゲームアカウントとは紐づきません。",
    "privacyReport": "プライバシーの詳細を読む"
  }
}
